(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[910],{

/***/ 8354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R_": function() { return /* binding */ isNextPaxBrandEnabled; },
/* harmony export */   "YS": function() { return /* binding */ brands; },
/* harmony export */   "hl": function() { return /* binding */ isImportBrandEnabled; },
/* harmony export */   "si": function() { return /* binding */ isBrandViaNextPax; }
/* harmony export */ });
/* unused harmony exports importBrandsList, brandsViaNextPaxList */
var brands = {
  interhome: {
    id: 'interhome',
    name: 'Interhome',
    contactUrl: 'https://www.interhome.no/kundeservice/',
    termsUrl: 'https://www.interhome.no/kundeservice/bestillingsvilkar/',
    unleashId: 'interhomeDirectBooking'
  },
  belvilla: {
    id: 'belvilla',
    name: 'Belvilla',
    contactUrl: 'https://www.belvilla.com/contact-us',
    termsUrl: 'https://www.belvilla.com/service',
    unleashId: 'belvillaDirectBooking'
  },
  dancenter: {
    id: 'dancenter',
    name: 'DanCenter',
    contactUrl: 'https://www.dancenter.no/kontakt.html',
    termsUrl: 'https://www.dancenter.no/info/leiebetingelser/',
    unleashId: 'dancenterDirectBooking'
  },
  // TODO REIS-5730 Remove when DanCenter through NextPax is in production
  dancenter_np: {
    id: 'dancenter',
    name: 'DanCenter',
    contactUrl: 'https://www.dancenter.no/kontakt.html',
    termsUrl: 'https://www.dancenter.no/info/leiebetingelser/',
    unleashId: 'dancenterDirectBooking'
  },
  danland: {
    id: 'danland',
    name: 'Danland',
    contactUrl: 'https://www.danland.no/callback.html',
    termsUrl: 'https://www.danland.no/info/leiebetingelser/',
    unleashId: 'danlandDirectBooking'
  },
  sologstrand: {
    id: 'sologstrand',
    name: 'Sol og Strand',
    contactUrl: 'https://www.sologstrand.no/kundeservice',
    termsUrl: 'https://www.sologstrand.no/praktiske-info/bestillinger',
    unleashId: 'sologstrandDirectBooking'
  },
  tui: {
    id: 'tui',
    name: 'TUI',
    contactUrl: 'TODO',
    termsUrl: 'https://www.tuivillas.com/us_en/terms_and_conditions',
    unleashId: 'tuiDirectBooking'
  },
  yourrentals: {
    id: 'yourrentals',
    name: 'Your.Rentals',
    contactUrl: 'TODO',
    termsUrl: 'TODO',
    unleashId: 'yourrentalsDirectBooking'
  },
  novasol: {
    id: 'novasol',
    name: 'Novasol',
    contactUrl: 'https://www.novasol.no/hjelp',
    termsUrl: 'https://www.novasol.no/hjelp/generelle-vilkar-og-leiebetingelser',
    unleashId: 'novasolDirectBooking'
  }
};
var importBrandsList = function importBrandsList() {
  return Object.values(brands);
};
var brandsViaNextPaxList = function brandsViaNextPaxList() {
  return Object.values(brands).filter(function (brand) {
    return brand.name !== 'Novasol';
  });
};
var isBrandViaNextPax = function isBrandViaNextPax(brandId) {
  return Object.keys(brands).filter(function (id) {
    return id !== 'novasol';
  }).includes(brandId);
};
var isImportBrandEnabled = function isImportBrandEnabled(brandName, unleash) {
  var _unleash$matchedBrand;

  var matchedBrand = importBrandsList().find(function (brand) {
    return brand.name === brandName;
  });
  return (_unleash$matchedBrand = unleash[matchedBrand === null || matchedBrand === void 0 ? void 0 : matchedBrand.unleashId]) !== null && _unleash$matchedBrand !== void 0 ? _unleash$matchedBrand : false; // return false if not an import brand or if unleash toggle is not setup
};
var isNextPaxBrandEnabled = function isNextPaxBrandEnabled(brandName, unleash) {
  if (brandName === 'Novasol') {
    return false;
  } else {
    return isImportBrandEnabled(brandName, unleash);
  }
};

/***/ }),

/***/ 7521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ truncateWithEllipsis; }
/* harmony export */ });
var truncateWithEllipsis = function truncateWithEllipsis(string, maxLength) {
  if ((string === null || string === void 0 ? void 0 : string.length) > maxLength) {
    // If maxLength is < 3 just return all 3 dots to simplify logic
    return string.slice(0, Math.max(maxLength - 3, 0)) + '...';
  } else {
    return string;
  }
};

/***/ }),

/***/ 1666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ ObjectPage; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__(9051);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/lib/tracking/tracking.js
var tracking = __webpack_require__(5151);
;// CONCATENATED MODULE: ./src/lib/tracking/objectTracking.js
// Implementation mostly copied from mfinn's trackAd.js and eventcollectorservice.js
var sendBeacon = function sendBeacon(url) {
  var imageNode = new Image();
  imageNode.setAttribute('src', url.toString());
};

var addTrackingData = function addTrackingData(url, adId, counterId) {
  // Weird double encoded query is by "design". Bulk tracker sends multiple query encoded entries
  url.searchParams.append('e', "&ecType=AD&finnkode=".concat(adId, "&ecCategory=").concat(counterId));
};

var trackAdView = function trackAdView(_ref) {
  var adId = _ref.adId;

  if (!adId || isNaN(Number(adId))) {
    // eslint-disable-next-line no-console
    console.error('adId should only contain numbers');
    return;
  }

  var currentUrl = new URL(document.baseURI);
  var trackingUrl = new URL(currentUrl.origin);
  trackingUrl.pathname += 'ec/b';
  trackingUrl.searchParams.set('client.application', 'travel-app');
  trackingUrl.searchParams.set('referer', document.referrer);

  if (!currentUrl.searchParams.get('s')) {
    addTrackingData(trackingUrl, adId, 'NoOfPageViews_Main');
  }

  if (currentUrl.searchParams.get('ecid')) {
    addTrackingData(trackingUrl, adId, currentUrl.searchParams.get('ecid'));
  }

  sendBeacon(trackingUrl);
};
// EXTERNAL MODULE: ./src/ducks/object/objectActions.ts
var objectActions = __webpack_require__(5021);
// EXTERNAL MODULE: ./src/components/breadcrumbs/Breadcrumbs.jsx
var Breadcrumbs = __webpack_require__(4995);
// EXTERNAL MODULE: ../../shared/frontend-resources/src/util/podletMessageBusEvents.js
var podletMessageBusEvents = __webpack_require__(5853);
;// CONCATENATED MODULE: ./src/lib/helpers/banner.ts

var publishBannerEvent = function publishBannerEvent(location) {
  var city = '';
  var country = '';

  if (location) {
    var _location$address, _location$address$spl, _location$address2, _location$address2$sp;

    city = (location === null || location === void 0 ? void 0 : location.locality) || (location === null || location === void 0 ? void 0 : (_location$address = location.address) === null || _location$address === void 0 ? void 0 : (_location$address$spl = _location$address.split(',')) === null || _location$address$spl === void 0 ? void 0 : _location$address$spl.slice(-2)[0].trim()) || null;
    country = (location === null || location === void 0 ? void 0 : location.country) || (location === null || location === void 0 ? void 0 : (_location$address2 = location.address) === null || _location$address2 === void 0 ? void 0 : (_location$address2$sp = _location$address2.split(',')) === null || _location$address2$sp === void 0 ? void 0 : _location$address2$sp.slice(-1)[0].trim()) || null;
  } // @ts-ignore convert this function to ts


  (0,podletMessageBusEvents/* initialBannerPublishEvent */.Lx)({
    pageType: 'object',
    country: country,
    city: city
  });
};
// EXTERNAL MODULE: ../../node_modules/@fabric-ds/icons/react/index.js + 444 modules
var icons_react = __webpack_require__(1326);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(2779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/@finn-no/create-element/index.js
var create_element = __webpack_require__(4660);
;// CONCATENATED MODULE: ./src/lib/gallery/lightbox.js
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

 // Note: this class now uses both Spaden and Troika classes in a transitioning period.

var noop = function noop() {
  /* Does nothing */
};

function setupLightbox(ele) {
  if ((0,create_element/* default */.ZP)('div', {
    style: 'display: -webkit-flex; display: -ms-flex; display: flex;'
  }).style.display === '') {
    // Flexbox not supported, no lightbox for you
    return;
  }

  ele.addEventListener('click', handleOpenLightboxClick);
  var lightbox;
  var thumbsContainer;
  var imageContainer;
  var contentEle;
  var captionEle;
  var counterEle;
  var infoEle;
  var closeButton;
  var showThumbsButton;
  var showLargeImageButton;
  var focusTrap;
  var navButtonsEle;
  var imageWrapper;
  var thumbsWrapper;
  var currentImageIndex = 0;
  var openerElement;
  var isProbablyTouchDevice = /mobi|tablet/i.test(navigator.userAgent); // this will do for now

  var imageList = getImageList(ele.getAttribute('data-gallerylightbox-name'));
  var thumbsVisible = imageList.length !== 1;

  function handleOpenLightboxClick(e) {
    if (e.button !== 0 || e.metaKey || e.shiftKey || e.ctrlKey || e.altKey) {
      return;
    }

    if (e.target.closest('[data-next]') || e.target.closest('[data-prev]')) {
      return;
    }

    e.preventDefault();
    openerElement = document.activeElement;
    var startIndex = 0;
    var element = e.target.closest('[data-index]');

    if (element) {
      startIndex = Number(element.getAttribute('data-index'));
    }

    setupLightBox(startIndex); // Need this to close lightbox when active history changes (return to previous page)

    window.onpopstate = function () {
      handleCloseClick();
      window.onpopstate = noop;
    };
  }

  function handleThumbClick(e) {
    e.preventDefault();
    hideThumbs();
    showMedia(Number(e.target.getAttribute('data-index')));
    lightbox.focus();
  }

  function handleCloseClick() {
    removeLightbox();
  }

  function handleToggleClick() {
    toggleThumbs();
  }

  function handleNextClick(event) {
    event.stopPropagation();
    showNextImage();
  }

  function handlePrevClick(event) {
    event.stopPropagation();
    showPrevImage();
  }

  function handleLightboxClick(e) {
    if (e.pageX > getDocumentWidth() / 2) {
      showNextImage();
    } else {
      showPrevImage();
    }
  }

  function handleKeyDown(e) {
    if (e.metaKey || e.altKey || e.shiftKey || e.ctrlKey) {
      return;
    }

    switch (e.keyCode) {
      case 32:
        // Space
        if (thumbsVisible) {
          hideThumbs();
          showMedia(Number(e.target.getAttribute('data-index')));
        } else {
          showThumbs();
        }

        break;

      case 27:
        // Esc
        removeLightbox();
        break;

      case 39:
        // Right arrow
        if (thumbsVisible) {
          focusNextThumb();
        } else {
          showNextImage();
        }

        break;

      case 37:
        // Left arrow
        if (thumbsVisible) {
          focusPrevThumb();
        } else {
          showPrevImage();
        }

        break;

      default:
        return;
    }

    e.stopPropagation();
    e.preventDefault();
  }

  function showNextImage() {
    showMedia((currentImageIndex + 1) % imageList.length);
  }

  function showPrevImage() {
    var index = (currentImageIndex - 1) % imageList.length;

    if (index < 0) {
      index += imageList.length;
    }

    showMedia(index);
  }

  function focusNextThumb() {
    if (document.activeElement.nextSibling) {
      document.activeElement.nextSibling.focus();
    } else {
      document.activeElement.parentNode.firstElementChild.focus();
    }
  }

  function focusPrevThumb() {
    if (document.activeElement.previousSibling) {
      document.activeElement.previousSibling.focus();
    } else {
      document.activeElement.parentNode.lastElementChild.focus();
    }
  }

  function showMedia(index) {
    var media = imageList[index];

    if (media.videoSrc) {
      showVideo(media, index);
    } else {
      showImage(media, index);
    }
  }

  function showVideo(video, index) {
    var videoType;

    if (video.videoSrc.indexOf('youtube') !== -1) {
      videoType = 'YT';
    }

    if (video.videoSrc.indexOf('vimeo') !== -1) {
      videoType = 'VI';
    }

    video.videoSrc = ele.querySelector('iframe').getAttribute('src');
    var videoId = video.videoSrc.split('/').pop();
    var swipeLayer = (0,create_element/* default */.ZP)('div.gallery-swipe-layer', {
      'data-video-swipe': ''
    });
    var videoEle = (0,create_element/* default */.ZP)('div.centered-image.gallery-full-size', null, isProbablyTouchDevice ? swipeLayer : null, (0,create_element/* default */.ZP)('meta', {
      name: 'WA.VIDEO',
      content: 'yes'
    }), (0,create_element/* default */.ZP)('meta', {
      name: 'WA.VIDEO_ID',
      content: videoId
    }), (0,create_element/* default */.ZP)('meta', {
      name: 'WA.VIDEO_TYPE',
      content: videoType
    }), (0,create_element/* default */.ZP)('div.media-container', null, (0,create_element/* default */.ZP)('iframe', {
      width: '640',
      height: '360',
      src: video.videoSrc,
      frameborder: 0,
      allowfullscreen: ''
    })));
    setVideoPreferences(video, videoEle, index, swipeLayer);
    preloadImages(index);
  }

  function setVideoPreferences(video, videoEle, index, swipeLayer) {
    imageWrapper.style.maxWidth = '1000px';
    imageWrapper.style.maxHeight = '667px';
    updateMedia(video, videoEle, index);

    if (swipeLayer) {
      swipeLayer.addEventListener('click', function (e) {
        e.stopPropagation();
        e.target.remove();
      });
    }
  }

  function showImage(img, index) {
    var element = (0,create_element/* default */.ZP)('img.lightbox-image-currentimage.lightbox__current-image', {
      srcset: img.srcset,
      src: img.src,
      'aria-label': img.caption,
      alt: ''
    });
    imageWrapper.style.maxWidth = img.width > 0 ? "".concat(img.width, "px") : '';
    imageWrapper.style.maxHeight = img.height > 0 ? "".concat(img.height, "px") : '';
    updateMedia(img, element, index);
    imageContainer.style.margin = '0';
    preloadImages(index);
  }

  function updateMedia(media, element, index) {
    captionEle.textContent = media.caption || "\u200B"; // Zero-width space to always reserve space

    counterEle.textContent = media.title || '';
    contentEle.replaceWith(element);
    contentEle = element;
    currentImageIndex = index;
  } // FIXME: this needs some serious refactoring


  function showThumbs() {
    imageContainer.classList.add('u-display-none', 'hidden');
    showLargeImageButton.classList.remove('u-display-none', 'hidden');
    showLargeImageButton.classList.add('lightbox__toggle-button');
    showThumbsButton.classList.add('u-display-none', 'hidden');
    showThumbsButton.classList.remove('lightbox__toggle-button');
    counterEle.classList.add('invisible');
    captionEle.classList.add('u-display-none', 'hidden');
    navButtonsEle.classList.add('u-display-none', 'hidden');
    thumbsWrapper.classList.remove('u-display-none', 'hidden');
    infoEle.classList.remove('u-display-none', 'hidden');
    thumbsContainer.querySelector("[data-index='".concat(currentImageIndex, "']")).focus();
    lightbox.removeEventListener('touchmove', preventBackgroundScroll);
    thumbsVisible = true;
  }

  function hideThumbs() {
    showLargeImageButton.classList.add('u-display-none', 'hidden');
    showLargeImageButton.classList.remove('lightbox__toggle-button');
    showThumbsButton.classList.remove('u-display-none', 'hidden');
    showThumbsButton.classList.add('lightbox__toggle-button');
    thumbsWrapper.classList.add('u-display-none', 'hidden');
    infoEle.classList.add('u-display-none', 'hidden');
    imageContainer.classList.remove('u-display-none', 'hidden');
    counterEle.classList.remove('invisible');
    captionEle.classList.remove('u-display-none', 'hidden');
    navButtonsEle.classList.remove('u-display-none', 'hidden'); // For some reason, when focusing this in Firefox, the click handler is invoked.
    // setTimeout avoids the issue

    window.setTimeout(function () {
      showThumbsButton.focus();
    }, 200);
    lightbox.addEventListener('touchmove', preventBackgroundScroll);
    thumbsVisible = false;
  }

  function toggleThumbs() {
    if (thumbsVisible) {
      hideThumbs();
    } else {
      showThumbs();
    }
  }

  function removeLightbox() {
    openerElement.focus();
    removeTempStyle();
    lightbox.remove();
    lightbox = null;
    imageContainer.removeEventListener('swipeleft', showPrevImage);
    imageContainer.removeEventListener('swiperight', showNextImage);
  }

  function createFocusLoops() {
    lightbox.addEventListener('focus', function () {
      if (showThumbsButton.classList.contains('hidden')) {
        showLargeImageButton.focus();
      } else {
        showThumbsButton.focus();
      }
    });
    contentEle.addEventListener('focus', function () {
      lightbox.focus();
    });
    focusTrap.addEventListener('focus', function () {
      lightbox.focus();
    });
  }

  function preventBackgroundScroll(e) {
    if (e.touches.length === 1) {
      e.preventDefault();
    }
  }

  function applyTempStyle() {
    document.documentElement.style.overflow = document.body.style.overflow = 'hidden';
    document.documentElement.style.position = document.body.style.position = 'relative';
    document.documentElement.style.height = document.body.style.height = '100%';
  }

  function removeTempStyle() {
    document.documentElement.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('position');
    document.documentElement.style.removeProperty('height');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('height');
  }

  function setupLightBox(startIndex) {
    currentImageIndex = startIndex;
    thumbsVisible = false;
    renderLightbox();
    applyTempStyle();

    if (thumbsVisible) {
      renderThumbs();
      showThumbs();
      showMedia(currentImageIndex);
    } else {
      showMedia(currentImageIndex);
      hideThumbs();
      renderThumbs();
    }

    imageContainer.addEventListener('swipeleft', showNextImage);
    imageContainer.addEventListener('swiperight', showPrevImage);
    lightbox.addEventListener('keydown', handleKeyDown);
    createFocusLoops();
  }

  function renderLightbox() {
    if (lightbox) {
      return;
    }

    counterEle = (0,create_element/* default */.ZP)('div.lightbox-imagecounter.text-white.font-bold.inline-block.lightbox__image-counter');
    thumbsContainer = (0,create_element/* default */.ZP)('div.lightbox-thumbs.text-center.px-8.lightbox__thumbs');
    thumbsWrapper = (0,create_element/* default */.ZP)('div.lightbox-thumbs-wrapper.lightbox__thumbs-wrapper', null, thumbsContainer);
    showThumbsButton = (0,create_element/* default */.ZP)('button.lightbox-toggle.blank.font-bold.text-white.clickable.inline-block.lightbox__toggle-button', {
      type: 'button',
      onclick: handleToggleClick,
      style: 'min-width: 170px; text-align: left;'
    }, (0,create_element/* default */.ZP)('svg:svg.align-middle.inline-block', {
      width: '18',
      height: '18',
      viewBox: '0 0 18 18'
    }, (0,create_element/* default */.ZP)('svg:path', {
      fill: '#fff',
      d: 'M1 1h4v4H1zM7 1h4v4H7zM13 1h4v4h-4zM1 7h4v4H1zM7 7h4v4H7zM13 7h4v4h-4zM1 13h4v4H1zM7 13h4v4H7zM13 13h4v4h-4z'
    })), (0,create_element/* default */.ZP)('span.align-middle.ml-4', null, 'Bildeoversikt'));
    showLargeImageButton = (0,create_element/* default */.ZP)('button.lightbox-toggle.blank.font-bold.text-white.clickable.inline-block.lightbox__toggle-button', {
      type: 'button',
      onclick: handleToggleClick,
      style: 'min-width: 170px; text-align: left;'
    }, (0,create_element/* default */.ZP)('svg:svg.align-middle.inline-block', {
      width: '18',
      height: '18',
      viewBox: '0 0 18 18'
    }, (0,create_element/* default */.ZP)('svg:path', {
      fill: '#fff',
      d: 'M1 1h16v16H1z'
    })), (0,create_element/* default */.ZP)('span.align-middle.ml-4.align-middle', null, 'Store bilder'));
    closeButton = (0,create_element/* default */.ZP)('button.lightbox-close.blank.font-bold.text-white.clickable.inline-block.lightbox__close-button', {
      type: 'button',
      onclick: handleCloseClick,
      'aria-label': 'Lukk',
      title: 'Lukk'
    }, (0,create_element/* default */.ZP)('svg:svg.align-middle', {
      width: '18',
      height: '18',
      viewBox: '0 0 18 18'
    }, (0,create_element/* default */.ZP)('svg:path', {
      stroke: '#fff',
      'stroke-width': '3',
      d: 'M2 2l14 14M16 2L2 16'
    })));
    captionEle = (0,create_element/* default */.ZP)('p.text-center.text-white.font-bold.lightbox__caption', {
      'aria-live': 'polite'
    });
    contentEle = (0,create_element/* default */.ZP)('img.lightbox-image-currentimage.lightbox__current-image');
    imageWrapper = (0,create_element/* default */.ZP)('div.lightbox-image-wrapper.lightbox__image-wrapper', null, contentEle);
    imageContainer = (0,create_element/* default */.ZP)('div.lightbox-body.clickable.m-0.no-select.lightbox__body', {
      onclick: handleLightboxClick
    }, imageWrapper);
    focusTrap = (0,create_element/* default */.ZP)('div.lightbox-focustrap', {
      tabindex: 0
    });
    navButtonsEle = (0,create_element/* default */.ZP)('div', null, (0,create_element/* default */.ZP)('button.button-pill.lightbox-right.absolute.top-1/2.right-16', {
      type: 'button',
      onclick: handleNextClick,
      'aria-label': 'Neste bilde'
    }, (0,create_element/* default */.ZP)('svg:svg.block.lightbox-arrow-icon', {
      viewBox: '0 0 12 22',
      width: '20',
      height: '22'
    }, (0,create_element/* default */.ZP)('svg:path', {
      fill: 'none',
      stroke: '#fff',
      'stroke-width': '2',
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      d: 'M2 2l8 9-8 9'
    }))), (0,create_element/* default */.ZP)('button.button-pill.lightbox-left.absolute.top-1/2.left-16', {
      type: 'button',
      onclick: handlePrevClick,
      'aria-label': 'Forrige bilde'
    }, (0,create_element/* default */.ZP)('svg:svg.block.lightbox-arrow-icon', {
      viewBox: '0 0 12 22',
      width: '20',
      height: '22'
    }, (0,create_element/* default */.ZP)('svg:path', {
      fill: 'none',
      stroke: '#fff',
      'stroke-width': '2',
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      d: 'M10 2l-8 9 8 9'
    }))));
    infoEle = (0,create_element/* default */.ZP)('p.font-bold.text-center.text-white.lightbox__caption', null, 'Trykk ', (0,create_element/* default */.ZP)('kbd', null, 'Space'), ' for å veksle mellom oversikt og store bilder, ', (0,create_element/* default */.ZP)('kbd', {
      'aria-label': 'Pil venstre'
    }, '←'), ' ', (0,create_element/* default */.ZP)('kbd', {
      'aria-label': 'Pil høyre'
    }, '→'), ' for å bla, og ', (0,create_element/* default */.ZP)('kbd', null, 'Esc'), ' for å lukke');
    var ele2 = (0,create_element/* default */.ZP)('div.lightbox', {
      tabindex: 0,
      role: 'dialog',
      'aria-modal': 'true'
    }, (0,create_element/* default */.ZP)('div.lightbox-content.lightbox__content', null, (0,create_element/* default */.ZP)('div.lightbox-header.lightbox__header', null, counterEle, (0,create_element/* default */.ZP)('div.lightbox-buttons.pr-8.inline-block.lightbox__buttons', null, showLargeImageButton, showThumbsButton, closeButton)), imageContainer, captionEle, imageList.length > 1 ? navButtonsEle : null, thumbsWrapper, isProbablyTouchDevice ? null : infoEle, focusTrap));

    var _iterator = _createForOfIteratorHelper(document.getElementsByClassName('lightbox')),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var element = _step.value;
        element.parentElement.removeChild(element);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    lightbox = document.body.appendChild(ele2);
  }

  function renderThumbs() {
    calculateThumbSizes();
    imageList.forEach(function (image, index) {
      thumbsContainer.appendChild((0,create_element/* default */.ZP)('a.lightbox-thumbs-image.lightbox__thumb-link', {
        href: image.src,
        'data-index': index,
        onclick: handleThumbClick
      }, (0,create_element/* default */.ZP)('img.clickable.block.lightbox__thumb$.bg-white', {
        'data-index': index,
        src: image.thumbSrc || image.src,
        height: image.thumbHeight,
        width: image.thumbWidth || null,
        // if width is missing, don't set the attribute
        'aria-label': image.caption,
        alt: ''
      })));
    });
  }

  function getDocumentWidth() {
    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  }

  function getDocumentHeight() {
    return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  }

  function calculateThumbHeight() {
    var defaultThumbHeight = 150;
    var maxHeight = 155;
    var minHeight = 60;
    var imageMargin = 20; // Multiplying with 0.7 is ultimate caveman way to compensate for uneven line breaks and the top bar.

    var availableArea = getDocumentWidth() * getDocumentHeight() * 0.7;
    var thumbWidths = imageList.map(function (image) {
      if (!image.width || !image.height) {
        return Math.ceil(defaultThumbHeight * 1.333);
      }

      var ratio = image.width / image.height;
      var thumbWidth = defaultThumbHeight * ratio + imageMargin;
      return Math.ceil(thumbWidth);
    });
    var thumbArea = thumbWidths.reduce(function (prev, current) {
      return prev + current * (defaultThumbHeight + imageMargin);
    });
    var fillRatio = thumbArea / availableArea;
    var thumbHeight = Math.ceil(defaultThumbHeight / Math.sqrt(fillRatio));
    return Math.min(Math.max(thumbHeight, minHeight), maxHeight);
  }

  function calculateThumbSizes() {
    var height = calculateThumbHeight();
    var ratio = 1.33;
    imageList.forEach(function (img) {
      if (img.height && img.width) {
        ratio = img.width / img.height;
      }

      if (img.width) {
        img.thumbWidth = Math.ceil(height * ratio);
      }

      img.thumbHeight = height;
    });
  }

  function preloadImages(index) {
    var PRELOAD_COUNT = 5; // will preload next and previous

    var preloadIndexes = [];
    var imageListLength = imageList.length;
    var imageListLastIndex = imageListLength - 1;
    var startIndex = keepInRange(index - PRELOAD_COUNT);
    var endIndex = keepInRange(index + PRELOAD_COUNT);
    addToPreloadIndexes(startIndex, endIndex);

    if (startIndex === 0) {
      // add from end of imageList
      var _start = keepInRange(index - PRELOAD_COUNT + imageListLength);

      addToPreloadIndexes(_start, imageListLastIndex);
    }

    if (endIndex === imageListLastIndex) {
      // add from beginning of imageList
      var _end = keepInRange(index + PRELOAD_COUNT - imageListLength);

      addToPreloadIndexes(0, _end);
    }

    preloadIndexes.splice(preloadIndexes.indexOf(index), 1); // remove current index

    preloadIndexes.forEach(function (i) {
      preloadImage(imageList[i]);
    });

    function addToPreloadIndexes(from, to) {
      while (from <= to) {
        if (preloadIndexes.indexOf(from) === -1) {
          preloadIndexes.push(from++);
        } else {
          from++;
        }
      }
    }

    function keepInRange(i) {
      return Math.min(Math.max(i, 0), imageListLastIndex);
    }
  }

  function preloadImage(img) {
    // Note that the order is important here. `src` cannot be set before `srcset`,
    // otherwise we might end up loading two images.
    if (img.srcset) {
      (0,create_element/* default */.ZP)('img', {
        srcset: img.srcset,
        src: img.src
      });
    } else {
      (0,create_element/* default */.ZP)('img', {
        src: img.src
      });
    }
  }

  function getImageList(name) {
    var imageEles = document.querySelectorAll("img[data-gallerylightbox-name=".concat(name, "], svg[data-gallerylightbox-name=").concat(name, "]"));
    return Array.from(imageEles).map(function (img, index, arr) {
      return {
        src: img.getAttribute('data-src'),
        thumbSrc: img.getAttribute('data-thumb-src'),
        srcset: img.getAttribute('data-srcset'),
        caption: img.getAttribute('aria-label'),
        height: img.height,
        width: img.width,
        title: "".concat(index + 1, " av ").concat(arr.length)
      };
    });
  }
}
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6412);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(3089);
;// CONCATENATED MODULE: ./src/lib/gallery/imageCarousel.js



// Slightly modified version of mfinn's src/main/webapp/modules/lib/Carousel.js
var imageCarousel_noop = function noop() {
  /* Does nothing */
};

var ImageCarousel = /*#__PURE__*/function () {
  function ImageCarousel(container) {
    var navigationHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : imageCarousel_noop;

    (0,classCallCheck/* default */.Z)(this, ImageCarousel);

    this._containerEle = container;
    this._index = 0;
    this._childrenEles = Array.from(container.children);
    this._navigationHandler = navigationHandler;
    this.count = this._childrenEles.length;
    this.currentEle = this._childrenEles[0];
  }

  (0,createClass/* default */.Z)(ImageCarousel, [{
    key: "show",
    value: function show(index) {
      var _this = this;

      if (typeof index != 'number') {
        throw new TypeError('The `index` argument must be a number');
      }

      this._index = Math.max(0, Math.min(index, this.count - 1));
      var currentEle = this._childrenEles[this._index];

      this._navigationHandler(index, currentEle, this.count);

      window.requestAnimationFrame(function () {
        _this._childrenEles.forEach(function (ele) {
          ele.style.display = 'none';
        });

        currentEle.style.display = '';
        var imgEle = currentEle.querySelector('img');

        if (imgEle) {
          _this._loadLazyImage(imgEle);
        }
      });
      this.currentEle = currentEle;
      this.preload(4);
    }
  }, {
    key: "previous",
    value: function previous() {
      this.show(this._mod(this._index - 1, this.count));
    }
  }, {
    key: "next",
    value: function next() {
      this.show(this._mod(this._index + 1, this.count));
    }
    /**
     * Preload `count` images before and `count` images after the current index
     * where `count` is an integer.
     */

  }, {
    key: "preload",
    value: function preload(count) {
      var _this2 = this;

      if (typeof count != 'number') {
        throw new TypeError('The `count` argument must be a number');
      }

      var totalCount = count * 2;
      var startIndex = this._index - count; // Generate a range from `startIndex` of length `totalCount + 1`.
      // and map to get preloadable images

      new Array(totalCount + 1) // +1 to account for the current index
      .fill(startIndex).map(function (i, idx) {
        return _this2._mod(i + idx, _this2.count);
      }).sort() // Preload forwards first as this is the usual direction
      .map(function (i) {
        return _this2._childrenEles[i].querySelector('[data-src]');
      }).filter(function (ele) {
        return ele;
      }).forEach(this._loadLazyImage);
    }
  }, {
    key: "update",
    value: function update(container) {
      this._childrenEles = Array.from(container.children);
      this.count = this._childrenEles.length;
      this.currentEle = this._childrenEles[0];
      this.preload(4);
    }
  }, {
    key: "_loadLazyImage",
    value: function _loadLazyImage(ele) {
      if (ele.src) {
        return;
      }

      if (ele.hasAttribute('data-srcset')) {
        ele.srcset = ele.getAttribute('data-srcset');
        ele.removeAttribute('data-srcset');
      }

      ele.src = ele.getAttribute('data-src');
      ele.removeAttribute('data-src');
    }
  }, {
    key: "_mod",
    value: function _mod(n, m) {
      return (n % m + m) % m;
    }
  }]);

  return ImageCarousel;
}();


// EXTERNAL MODULE: ./src/scenes/objectPage/components/imageList/styles.module.css
var styles_module = __webpack_require__(9587);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/imageList/ImageList.jsx









function ImageList(_ref) {
  var adId = _ref.adId,
      heading = _ref.heading,
      images = _ref.images;
  var lightboxRef = (0,react.useRef)(null);
  var imageRef = (0,react.useRef)(null);
  var trackedImageview = (0,react.useRef)(false);

  var _useState = (0,react.useState)(),
      carousel = _useState[0],
      setCarousel = _useState[1];

  var hasImages = Boolean(images === null || images === void 0 ? void 0 : images.length);
  (0,react.useEffect)(function () {
    if (hasImages) {
      var updatedCarousel = new ImageCarousel(imageRef.current);
      setCarousel(updatedCarousel);
      updatedCarousel.preload(1); // preload one before and one after

      updatedCarousel.update(imageRef.current);
      setupLightbox(lightboxRef.current);
    }
  }, [hasImages, setCarousel]);
  (0,react.useEffect)(function () {
    if (carousel) {
      document.body.addEventListener('keydown', handleKeydown);
      return function () {
        document.body.removeEventListener('keydown', handleKeydown);
      };
    }
  }, [carousel]);

  var handleKeydown = function handleKeydown(event) {
    if (event.target.closest('input, textarea') || event.metaKey || event.altKey || event.shiftKey || event.ctrlKey) {
      return;
    }

    switch (event.keyCode) {
      case 37:
        // Left arrow
        handlePrevious(event);
        break;

      case 39:
        // Right arrow
        handleNext(event);
        break;
    }
  };

  var handlePrevious = function handlePrevious(event) {
    event.stopPropagation();
    carousel.previous();
    trackImageView();
  };

  var handleNext = function handleNext(event) {
    event.stopPropagation();
    carousel.next();
    trackImageView();
  };

  var trackImageView = function trackImageView() {
    // only track the first click on left/right arrows
    if (!trackedImageview.current) {
      trackPulse('View', 'View carousel image');
      trackedImageview.current = true;
    }
  };

  var trackPulse = function trackPulse(intent, name) {
    (0,tracking/* trackClick */.ob)({
      type: 'Click',
      intent: intent,
      name: name,
      object: {
        id: 'open_image_gallery',
        type: 'UIElement',
        elementType: 'Image',
        items: [{
          type: 'ClassifiedAd',
          id: adId,
          contentId: adId.toString(),
          name: heading,
          category: 'travel > holiday rental'
        }],
        hasExtendedProfile: false
      },
      vertical: {
        name: 'travel',
        subVertical: 'holiday_rental'
      }
    });
  };

  var poorResolution = function poorResolution(image) {
    return image.height < 768 && image.width < 768;
  };

  var renderHiddenImages = function renderHiddenImages() {
    return images.map(function (image, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        "data-src": image.src,
        "data-srcset": image.srcSet,
        height: image.height,
        width: image.width,
        "data-thumb-src": image.thumb155hSrc,
        "data-gallerylightbox-name": "ad",
        "aria-label": image.description,
        alt: "",
        "data-testid": "ObjectImages-hiddenImage-".concat(index)
      }, "hidden-image-".concat(image.src));
    });
  };

  var renderImages = function renderImages() {
    return images.map(function (image, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        href: "/gallery.html?finnkode=".concat(adId, "#image").concat(index),
        style: {
          display: index === 0 ? 'block' : 'none'
        },
        "data-testid": "ObjectImages-imageLink-".concat(index),
        children: [index === 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: classnames_default()((styles_module_default()).imageItemImg, 'img-format__img rounded-8'),
          sizes: "".concat(poorResolution(image) ? '(min-width: 768px) 768px' : '(min-width: 1200px) 80vw, (min-width: 768px) 100vw'),
          alt: image.description,
          "aria-label": "Galleribilde",
          src: image.src,
          srcSet: image.srcSet,
          "data-index": index,
          "data-testid": "ObjectImages-image-".concat(index)
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: classnames_default()((styles_module_default()).imageItemImg, 'img-format__img rounded-8'),
          sizes: "".concat(poorResolution(image) ? '(min-width: 768px) 768px' : '(min-width: 1200px) 80vw, (min-width: 768px) 100vw'),
          alt: image.description,
          "aria-label": "Galleribilde",
          "data-src": image.src,
          "data-srcset": image.srcSet,
          "data-index": index,
          "data-testid": "ObjectImages-image-".concat(index)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "absolute bottom-0 w-full text-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: "px-8 py-4 bg-gray-500 text-white rounded-4",
            children: ["(", index + 1, "/", images.length, ")", image.description]
          })
        })]
      }, "image-".concat(image.src));
    });
  };

  var renderImageContainer = function renderImageContainer() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      onClick: function onClick() {
        return trackPulse('Open', 'Open image gallery');
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        ref: imageRef,
        children: renderImages()
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: classnames_default()((styles_module_default()).button, 'button button--pill absolute top-1/2 right-16 text-white'),
        type: "button",
        "aria-label": "Neste bilde",
        "data-next": "true",
        "data-testid": "nextButton",
        onClick: handleNext,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_react/* IconChevronRight24 */.ZaJ, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: classnames_default()((styles_module_default()).button, 'button button--pill absolute top-1/2 left-16 text-white'),
        type: "button",
        "aria-label": "Forrige bilde",
        "data-prev": "true",
        "data-testid": "previousButton",
        onClick: handlePrevious,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_react/* IconChevronLeft24 */.ivF, {})
      })]
    });
  };

  var renderNoImages = function renderNoImages() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: "https://static.finncdn.no/_c/mfinn/static/images/no_image_universal.4e750c62.png",
      className: "img-format__img rounded-8 mx-auto",
      width: "320",
      height: "213",
      "data-testid": "defaultImage",
      alt: "Bilde mangler"
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "md:col-span-3 relative",
    "data-testid": "adImageContainer",
    tabIndex: -1,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "img-format img-format--ratio4by3 img-format--centered",
      tabIndex: -1,
      "data-gallerylightbox-name": "ad",
      "data-gallerylightbox-context": "mobile",
      ref: lightboxRef,
      children: hasImages ? renderImageContainer() : renderNoImages()
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hidden",
      children: hasImages && renderHiddenImages()
    })]
  });
}
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/next/config.js
var config = __webpack_require__(314);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/scenes/objectPage/utils.ts
var replacePropsWithPreview = function replacePropsWithPreview(normalProps, isPreview) {
  if (isPreview) {
    return {
      onClick: function onClick(e) {
        e.preventDefault();
        alert('Knapper og lenker er skrudd av under forhåndsvisning');
      }
    };
  } else {
    return normalProps;
  }
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/favoriteButton/FavoriteButton.jsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var _getConfig = config_default()(),
    favouriteBaseUri = _getConfig.publicRuntimeConfig.favouriteBaseUri;

var FavoriteButton = function FavoriteButton(_ref) {
  var adId = _ref.adId,
      loginId = _ref.loginId,
      isMobile = _ref.isMobile,
      isPreview = _ref.isPreview;

  var _useState = (0,react.useState)(undefined),
      favourite = _useState[0],
      setFavourite = _useState[1];

  (0,react.useEffect)(function () {
    if (!isPreview) {
      var setupFavouriteComponent = /*#__PURE__*/function () {
        var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
          var createFavouriteComponent, FavoriteComponent;
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return FavoriteButton.importFavoriteComponent();

                case 2:
                  createFavouriteComponent = _context.sent;
                  FavoriteComponent = createFavouriteComponent({
                    userId: loginId,
                    baseUri: favouriteBaseUri
                  }); // Cannot update state if something went wrong with creating the favourite component

                  if (FavoriteComponent) {
                    setFavourite( /*#__PURE__*/(0,jsx_runtime.jsx)(FavoriteComponent, {
                      itemId: adId,
                      isMobile: isMobile,
                      variant: "button",
                      itemType: "Ad",
                      title: "Lagre i Favoritter",
                      "aria-label": "Lagre i Favoritter"
                    }));
                  }

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function setupFavouriteComponent() {
          return _ref2.apply(this, arguments);
        };
      }();

      setupFavouriteComponent()["catch"](function (error) {
        // eslint-disable-next-line no-console
        console.error('Problems with favourite component', error);
      });
    }
  }, [loginId, adId, isMobile]);
  return typeof favourite === 'undefined' || isPreview ? /*#__PURE__*/(0,jsx_runtime.jsxs)("button", _objectSpread(_objectSpread({
    className: "button button-secondary button--has-icon",
    "aria-label": "Hjertemerke",
    "aria-haspopup": "dialog",
    "aria-pressed": "false"
  }, replacePropsWithPreview({}, isPreview)), {}, {
    "data-testid": "heartButton",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "icon App-module_iconHeartBlueNeutral__JafxO"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Legg til favoritt"
    })]
  })) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    "data-testid": "heartDiv",
    children: favourite
  });
}; // Need this to be able to mock out the dynamic import

FavoriteButton.importFavoriteComponent = /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
  return regenerator_default().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return Promise.all(/* import() */[__webpack_require__.e(235), __webpack_require__.e(601)]).then(__webpack_require__.bind(__webpack_require__, 5601));

        case 2:
          return _context2.abrupt("return", _context2.sent["default"]);

        case 3:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2);
}));
// EXTERNAL MODULE: ./src/scenes/objectPage/components/shareButtons/styles.module.css
var shareButtons_styles_module = __webpack_require__(6463);
var shareButtons_styles_module_default = /*#__PURE__*/__webpack_require__.n(shareButtons_styles_module);
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/shareButtons/ShareButtons.jsx








var ShareButtons = function ShareButtons(_ref) {
  var adId = _ref.adId,
      heading = _ref.heading,
      isEnabled = _ref.isEnabled;

  var track = function track(name, type) {
    if (isEnabled) {
      (0,tracking/* trackClick */.ob)({
        type: 'Click',
        intent: 'Share',
        name: 'Share ad',
        object: {
          id: "share_ad_".concat(name),
          type: 'UIElement',
          name: "".concat(type, " icon"),
          items: [{
            type: 'ClassifiedAd',
            id: adId,
            contentId: adId.toString(),
            name: heading,
            category: 'travel > holiday rental'
          }],
          hasExtendedProfile: false
        },
        vertical: {
          name: 'travel',
          subVertical: 'holiday_rental'
        }
      });
    }
  };

  var renderLinkTitle = function renderLinkTitle(enabledPrefix, disabledPrefix, postfix) {
    return isEnabled ? "".concat(enabledPrefix, " ").concat(postfix) : "N\xE5r annonsen er aktiv kan du ".concat(disabledPrefix, " ").concat(postfix);
  };

  var mailToLink = "mailto:?subject=Tips: ".concat(heading, "&body=Jeg fant dette p\xE5 finn.no: https://www.finn.no/").concat(adId);
  var facebookShareLink = "https://www.facebook.com/sharer/sharer.php?u=https://www.finn.no/".concat(adId, "?taid%3DShare_ad_facebook");
  var twitterShareLink = "https://twitter.com/intent/tweet?hashtags=FINN_no&related=Finn_no&url=https://www.finn.no/".concat(adId) + "?taid%3DShare_ad_twitter&text=".concat(heading);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "inline-block sm:space-x-4",
    "data-testid": "toolbar",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: classnames_default()((shareButtons_styles_module_default()).button, 'button button--pill p-8', (0,defineProperty/* default */.Z)({}, (shareButtons_styles_module_default())["button--highlight"], isEnabled)),
      title: renderLinkTitle('Tips', 'tipse', 'en venn'),
      href: isEnabled ? mailToLink : null,
      rel: "noopener noreferrer nofollow external",
      target: "_blank",
      "aria-disabled": !isEnabled,
      onClick: function onClick() {
        return track('tip-a-friend', 'Email');
      },
      "data-testid": "tipAFriend",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_react/* IconMail24 */.FJJ, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: classnames_default()((shareButtons_styles_module_default()).button, 'button button--pill p-8', (0,defineProperty/* default */.Z)({}, (shareButtons_styles_module_default())["button--highlight"], isEnabled)),
      title: renderLinkTitle('Del', 'dele', 'på Facebook'),
      href: isEnabled ? facebookShareLink : null,
      rel: "noopener noreferrer nofollow external",
      target: "_blank",
      "aria-disabled": !isEnabled,
      style: {
        color: !isEnabled ? '#dfe4e8' : ''
      },
      onClick: function onClick() {
        return track('share-facebook', 'Facebook');
      },
      "data-testid": "shareFacebook",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_react/* IconFacebook24 */.SdI, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: classnames_default()((shareButtons_styles_module_default()).button, 'button button--pill p-8', (0,defineProperty/* default */.Z)({}, (shareButtons_styles_module_default())["button--highlight"], isEnabled)),
      title: renderLinkTitle('Del', 'dele', 'på Twitter'),
      href: isEnabled ? twitterShareLink : null,
      rel: "noopener noreferrer nofollow external",
      target: "_blank",
      "aria-disabled": !isEnabled,
      style: {
        color: !isEnabled ? '#dfe4e8' : ''
      },
      onClick: function onClick() {
        return track('share-twitter', 'Twitter');
      },
      "data-testid": "shareTwitter",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_react/* IconTwitter24 */.JX9, {})
    })]
  });
};
// EXTERNAL MODULE: ./src/utils/price.ts
var price = __webpack_require__(9866);
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/pricingEntry/PricingEntry.jsx



var PricingEntry = function PricingEntry(_ref) {
  var description = _ref.description,
      value = _ref.value;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "text-16 font-bold",
      children: description
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "text-22 font-bold",
      children: value
    })]
  });
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/pricing/Pricing.jsx





var Pricing = function Pricing(_ref) {
  var pricing = _ref.pricing,
      firstColumnList = _ref.firstColumnList,
      secondColumnList = _ref.secondColumnList;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "grid md:grid-cols-2 gap-16",
    "data-testid": "adPricing",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "grid gap-16",
      "data-testid": "entry-col-1",
      children: [(0,price/* generateEntries */.zF)(price/* priceDescription */.dX, pricing).map(function (entry) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(PricingEntry, {
          description: entry.description,
          value: entry.value
        }, "price-".concat(entry.key));
      }), Boolean(firstColumnList === null || firstColumnList === void 0 ? void 0 : firstColumnList.length) && firstColumnList.map(function (_ref2) {
        var description = _ref2.description,
            value = _ref2.value;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(PricingEntry, {
          description: description,
          value: value
        }, "".concat(description, "-").concat(value));
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "grid gap-16",
      "data-testid": "entry-col-2",
      children: [(0,price/* generateEntries */.zF)(price/* additionalDescription */.iP, pricing).map(function (entry) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(PricingEntry, {
          description: entry.description,
          value: entry.value
        }, "price-".concat(entry.key));
      }), Boolean(secondColumnList === null || secondColumnList === void 0 ? void 0 : secondColumnList.length) && secondColumnList.map(function (_ref3) {
        var description = _ref3.description,
            value = _ref3.value;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(PricingEntry, {
          description: description,
          value: value
        }, "".concat(description, "-").concat(value));
      })]
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/@finn-no/legacy-fabric-datepicker-nopopover/dist/index.js
var dist = __webpack_require__(9906);
// EXTERNAL MODULE: ../../node_modules/@fabric-ds/react/dist/npm/index.js
var npm = __webpack_require__(3517);
// EXTERNAL MODULE: ../../shared/frontend-resources/src/util/datetime-fns.ts
var datetime_fns = __webpack_require__(3979);
// EXTERNAL MODULE: ./src/lib/helpers/importBrands.ts
var importBrands = __webpack_require__(8354);
// EXTERNAL MODULE: ../../shared/frontend-resources/src/util/formatting.js
var formatting = __webpack_require__(6235);
// EXTERNAL MODULE: ../../node_modules/swr/dist/index.mjs
var swr_dist = __webpack_require__(9857);
// EXTERNAL MODULE: ./src/api/api.ts + 1 modules
var api = __webpack_require__(5332);
;// CONCATENATED MODULE: ./src/lib/hooks/availability.ts



var useAvailability = function useAvailability(adId, startDate, endDate) {
  var shouldFetch = !!startDate; // only fetch availability data when a date is selected

  var key = shouldFetch ? {
    adId: adId,
    startDate: (0,datetime_fns/* formatISODate */.cz)(startDate),
    endDate: endDate ? (0,datetime_fns/* formatISODate */.cz)(endDate) : null
  } : null;

  var _useSWR = (0,swr_dist/* default */.ZP)(key, api/* fetchCalendarAvailability */.$k, {
    revalidateOnFocus: false
  }),
      data = _useSWR.data,
      error = _useSWR.error;

  return {
    availability: error ? {
      error: error
    } : data === null || data === void 0 ? void 0 : data.availability,
    price: data === null || data === void 0 ? void 0 : data.price,
    loading: shouldFetch && !data && !error
  };
};
// EXTERNAL MODULE: ../../shared/frontend-resources/src/icons/SpinnerIcon.tsx
var SpinnerIcon = __webpack_require__(2208);
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/availability/Availability.tsx











var Availability_getConfig = config_default()(),
    contextPath = Availability_getConfig.publicRuntimeConfig.contextPath;

/**
 * Shows booking availability info/warning alert, price info for selected period, and the direct booking button.
 */
var Availability = function Availability(_ref) {
  var adId = _ref.adId,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      novasolButton = _ref.novasolButton;

  var _useState = (0,react.useState)(false),
      showButtonWarning = _useState[0],
      setShowButtonWarning = _useState[1];

  var _useAvailability = useAvailability(adId, startDate, endDate),
      availability = _useAvailability.availability,
      price = _useAvailability.price,
      loading = _useAvailability.loading;

  (0,react.useEffect)(function () {
    if (startDate && endDate) {
      setShowButtonWarning(false);
    }
  }, [startDate, endDate]);

  var handleClick = function handleClick() {
    if (!startDate || !endDate) {
      setShowButtonWarning(true);
    }
  };

  var renderAlert = function renderAlert() {
    var alert = {
      type: 'negative'
    };
    if (availability !== null && availability !== void 0 && availability.error) alert.message = 'Oisann, det ser ut som systemet vårt er nede. Prøv igjen senere.';else if ((availability === null || availability === void 0 ? void 0 : availability.isCheckinAllowed) === false) alert.message = 'Ingen innsjekk denne dagen.';else if ((availability === null || availability === void 0 ? void 0 : availability.isCheckoutAllowed) === false) alert.message = 'Ingen utsjekk denne dagen.';else if (availability !== null && availability !== void 0 && availability.isLessThanMinStay) alert.message = "Minimum opphold ".concat(availability.minStay, " netter.");else if (availability !== null && availability !== void 0 && availability.isMoreThanMaxStay) alert.message = "Maximum opphold ".concat(availability.maxStay, " netter.");else if ((availability === null || availability === void 0 ? void 0 : availability.isAvailable) === false || (price === null || price === void 0 ? void 0 : price.available) === false) alert.message = 'Denne perioden er dessverre ikke tilgjengelig for leie. Prøv en annen dato.';else if (startDate && !endDate && availability !== null && availability !== void 0 && availability.minStay) alert = {
      message: "Minimum opphold ".concat(availability.minStay, " netter."),
      type: 'info'
    };
    return alert.message ?
    /*#__PURE__*/
    // @ts-ignore
    (0,jsx_runtime.jsx)(npm/* Alert */.bZ, {
      type: "".concat(alert.type),
      show: true,
      children: alert.message
    }) : null;
  };

  var renderDirectBookingButton = function renderDirectBookingButton() {
    var priceInfo = price !== null && price !== void 0 && price.available ? "".concat((0,formatting/* thousandSeparated */.IK)(price.totalPrice), " ").concat(price.currencySymbol) : null;
    var directBookingAvailable = priceInfo && startDate && endDate;
    var href = directBookingAvailable ? "".concat(contextPath, "/bestill/?finnkode=").concat(adId, "&fra=").concat((0,datetime_fns/* formatISODate */.cz)(startDate), "&til=").concat((0,datetime_fns/* formatISODate */.cz)(endDate)) : undefined;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [directBookingAvailable ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "font-bold text-left",
          children: "Pris"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "grid grid-cols-".concat(priceInfo ? '3' : '1', " gap-16 my-8 text-left"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat(priceInfo ? 'col-span-2' : ''),
            children: price !== null && price !== void 0 && price.available ? "".concat((0,datetime_fns/* formatReadableDateShortNoWeekday */.kr)(startDate), " - ").concat((0,datetime_fns/* formatReadableDateShortNoWeekday */.kr)(endDate)) : ''
          }), Boolean(priceInfo) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "font-bold text-right",
            children: priceInfo
          })]
        })]
      }) : null, novasolButton && !directBookingAvailable ? novasolButton : /*#__PURE__*/(0,jsx_runtime.jsx)(npm/* Button */.zx, {
        primary: true,
        className: "w-full max-w-full",
        href: href,
        onClick: handleClick,
        "data-testid": "importAdButton",
        children: "G\xE5 til bestilling"
      }), showButtonWarning ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-14 text-red-600 mt-8 text-center",
        children: "Du m\xE5 velge en leieperiode for \xE5 bestille"
      }) : novasolButton && price !== null && price !== void 0 && price.message ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-14 text-red-600 mt-8 text-center",
        children: price === null || price === void 0 ? void 0 : price.message
      }) : null]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [loading && /*#__PURE__*/(0,jsx_runtime.jsx)(SpinnerIcon/* SpinnerIcon */.L, {
      className: "mt-16 mx-auto"
    }), renderAlert(), renderDirectBookingButton()]
  });
};
// EXTERNAL MODULE: ./src/scenes/objectPage/components/calendar/styles.module.css
var calendar_styles_module = __webpack_require__(8663);
var calendar_styles_module_default = /*#__PURE__*/__webpack_require__.n(calendar_styles_module);
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/calendar/Calendar.jsx


function Calendar_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Calendar_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Calendar_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Calendar_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var Calendar_getConfig = config_default()(),
    Calendar_contextPath = Calendar_getConfig.publicRuntimeConfig.contextPath;

var disclaimer = 'FINN.no forbeholder seg retten til å kontrollere meldingene og stoppe useriøs e-post.';
function Calendar(_ref) {
  var loginCookieCsrfToken = _ref.loginCookieCsrfToken,
      isLoggedIn = _ref.isLoggedIn,
      unleash = _ref.unleash;
  var filters = (0,es/* useSelector */.v9)(function (state) {
    return state.results.filters;
  });
  var objectData = (0,es/* useSelector */.v9)(function (state) {
    return state.objectData;
  });
  var adId = objectData.adId,
      bookings = objectData.bookings,
      isAdmin = objectData.isAdmin,
      isImport = objectData.isImport,
      owner = objectData.owner,
      user = objectData.user;
  var isPreview = Boolean(objectData.isPreview);
  var bookingEnabled = Boolean(objectData.bookingEnabled);

  var _useState = (0,react.useState)(filters !== null && filters !== void 0 && filters.booking_from ? new Date(filters.booking_from) : null),
      startDate = _useState[0],
      setStartDate = _useState[1];

  var _useState2 = (0,react.useState)(filters !== null && filters !== void 0 && filters.booking_to ? new Date(filters.booking_to) : null),
      endDate = _useState2[0],
      setEndDate = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      deepLinkParams = _useState3[0],
      setDeepLink = _useState3[1];

  var _useState4 = (0,react.useState)(Boolean(startDate && endDate)),
      isContactFormVisible = _useState4[0],
      setIsContactFormVisible = _useState4[1];

  var _useState5 = (0,react.useState)(''),
      bookingPeriod = _useState5[0],
      setBookingPeriod = _useState5[1];

  if (!bookingEnabled) {
    return null;
  }

  var handleDateSelect = function handleDateSelect(dates) {
    if (isPreview) {
      return;
    }

    setStartDate(dates.startDate);
    setEndDate(dates.endDate);

    if (dates.startDate && dates.endDate) {
      setIsContactFormVisible(true);
      setDeepLink(generatePeriodParamsForUrl(dates.startDate, dates.endDate));
      setBookingPeriod("".concat((0,datetime_fns/* formatClientDate */.Y$)(dates.startDate), " - ").concat((0,datetime_fns/* formatClientDate */.Y$)(dates.endDate)));
    } else {// one or no dates selected, do nothing
    }
  };

  var handleDateReset = function handleDateReset() {
    setBookingPeriod('');
    setDeepLink('');
    setStartDate(null);
    setEndDate(null);
  };

  var trackContactMessageSent = function trackContactMessageSent() {
    (0,tracking/* trackSendMessage */.eF)({
      objectName: 'with calendar',
      objectData: objectData,
      fromDate: startDate ? (0,datetime_fns/* formatISODate */.cz)(startDate) : null,
      toDate: endDate ? (0,datetime_fns/* formatISODate */.cz)(endDate) : null
    });
  };

  var generatePeriodParamsForUrl = function generatePeriodParamsForUrl(from, to) {
    if (!from || !to) {
      return;
    }

    if ((owner === null || owner === void 0 ? void 0 : owner.name) === 'DanCenter') {
      var _safeDifferenceInCale;

      return "&firstdate=".concat((0,datetime_fns/* formatYMDDate */.a$)(from), "&days=").concat((_safeDifferenceInCale = (0,datetime_fns/* safeDifferenceInCalendarDays */.EW)(from, to)) !== null && _safeDifferenceInCale !== void 0 ? _safeDifferenceInCale : 1);
    }

    if ((owner === null || owner === void 0 ? void 0 : owner.name) === 'Novasol') {
      return "&from=".concat((0,datetime_fns/* formatYMDDate */.a$)(from), "&to=").concat((0,datetime_fns/* formatYMDDate */.a$)(to));
    }

    return '';
  };

  var renderImportAdButton = function renderImportAdButton() {
    return owner ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: "button button--primary w-full max-w-full",
        onClick: function onClick() {
          return (0,tracking/* trackCheckPriceAndAvailability */.NV)({
            objectData: objectData
          });
        },
        href: "".concat(Calendar_contextPath, "/ut?finnkode=").concat(adId, "&deepLinkParams=").concat(deepLinkParams !== '' ? btoa(deepLinkParams) : ''),
        target: "_blank",
        rel: "noopener noreferrer nofollow external",
        "data-testid": "importAdButton",
        children: "Se pris og tilgjengelighet"
      }), isImport && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-12 mt-8",
        children: "OBS! I enkelte perioder kan man kun leie hele uker."
      })]
    }) : null;
  };

  var renderForm = function renderForm() {
    return user ? /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      action: "/contact.html",
      method: "post",
      id: "contact_form",
      "data-testid": "contactForm",
      onSubmit: trackContactMessageSent,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        type: "hidden",
        name: "finnkode",
        defaultValue: adId || ''
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        type: "hidden",
        name: "from_email",
        id: "from_email",
        defaultValue: user.email
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        type: "hidden",
        name: "csrfToken",
        defaultValue: loginCookieCsrfToken
      }), isContactFormVisible ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mt-16 text-left space-y-16",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "input input--text",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            className: "required",
            htmlFor: "daterange",
            children: "Velg periode i kalenderen eller skriv inn her"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: "text",
            id: "daterange",
            value: bookingPeriod,
            name: "extraParams[date_range]",
            placeholder: "DD.MM.YYYY - DD.MM.YYYY",
            onChange: function onChange(event) {
              return setBookingPeriod(event.target.value);
            },
            "data-testid": "contactDateRange"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "input input--textarea",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            className: "required",
            htmlFor: "message",
            children: "Melding til utleier"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", {
            rows: "5",
            name: "message",
            id: "message",
            placeholder: "Ta gjerne med antall personer",
            required: true,
            "data-testid": "contactMessage"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "input input--text input--is-read-only",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            className: "required",
            htmlFor: "from_email",
            children: "E-post"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: "email",
            name: "from_email",
            id: "from_email",
            required: true,
            disabled: true,
            defaultValue: user.email,
            "data-testid": "contactEmail"
          }), user.email && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "text-14",
            href: "/min-finn/min-konto",
            children: "Du kan endre denne e-postadressen i profilen din"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "input input--text",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            className: "required",
            htmlFor: "phone_number",
            children: "Telefonnummer"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: "text",
            name: "extraParams[phone_number]",
            id: "phone_number",
            defaultValue: user.phone,
            placeholder: "Ta gjerne med landskode",
            "data-testid": "contactPhoneNumber"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "input",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: "button button--primary mb-16",
            type: "submit",
            id: "submit",
            children: "Send melding"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: "button button--tertiary mb-16 ml-16",
            type: "button",
            id: "cancel",
            onClick: function onClick() {
              return setIsContactFormVisible(false);
            },
            children: "Avbryt"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-14 mb-16",
            children: disclaimer
          })]
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", Calendar_objectSpread(Calendar_objectSpread({
          className: "button button--primary my-16 w-full max-w-full"
        }, replacePropsWithPreview({
          onClick: function onClick(e) {
            e.preventDefault();
            setIsContactFormVisible(true);
          }
        }, isPreview)), {}, {
          children: "Skriv en melding til utleier"
        })), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-14 mb-16",
          children: disclaimer
        })]
      })]
    }) : null;
  };

  var renderContent = function renderContent() {
    return isLoggedIn ? renderForm() : /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: "button button--primary my-16 w-full max-w-full",
      "data-testid": "loginLink",
      href: "/auth/login",
      children: "Logg inn for \xE5 sende melding"
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "space-y-16 my-16",
    "data-testid": "adCalendar",
    "aria-labelledby": "objectCalendarHeading",
    children: [(0,importBrands/* isNextPaxBrandEnabled */.R_)(owner === null || owner === void 0 ? void 0 : owner.name, unleash) ? /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      className: "h4",
      id: "objectCalendarHeading",
      children: "Finn ledig tid i kalenderen"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      className: "h4",
      id: "objectCalendarHeading",
      children: "Kalender for ledighet"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* DateRangePicker */.Dw, {
        bookedDates: bookings !== null && bookings !== void 0 ? bookings : [],
        startDate: startDate,
        endDate: endDate,
        minimumNights: 1,
        isDayDisabled: datetime_fns/* isPast */.CR,
        onChange: handleDateSelect,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* DatePickerCalendar */.hx, {
          numberOfMonths: 1,
          className: classnames_default()((calendar_styles_module_default()).datePicker, '-mx-32 border lg:border-none'),
          "data-testid": "object-calendar"
        })
      })
    }), startDate && endDate ? /*#__PURE__*/(0,jsx_runtime.jsx)(npm/* Button */.zx, {
      link: true,
      small: true,
      onClick: handleDateReset,
      "data-testid": "object-calendar-reset",
      children: "Nullstill datoer"
    }) : null, (0,importBrands/* isImportBrandEnabled */.hl)(owner === null || owner === void 0 ? void 0 : owner.name, unleash) ? /*#__PURE__*/(0,jsx_runtime.jsx)(Availability, {
      adId: adId,
      startDate: startDate,
      endDate: endDate,
      novasolButton: (owner === null || owner === void 0 ? void 0 : owner.name) === 'Novasol' ? renderImportAdButton() : null
    }) : isImport || isAdmin && owner.deeplink ? renderImportAdButton() : renderContent()]
  });
}
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/infoIcons/InfoIcons.jsx
/* eslint-disable max-len */



var EstateSizeIcon = function EstateSizeIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "32",
    height: "32",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      stroke: "#767676",
      strokeWidth: "1.95",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M15.125 22.925v3.9a1.95 1.95 0 001.95 1.95h7.8a1.95 1.95 0 001.95-1.95v-3.9M30.725 20.975l-8.446-7.605a1.95 1.95 0 00-2.608 0l-8.446 7.605M28.775 19.22v-5.07"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M30.725 2.45a.975.975 0 00-.975-.975H2.45a.975.975 0 00-.975.975v27.3c0 .538.437.975.975.975h3.9a.975.975 0 00.975-.975V7.325H29.75a.975.975 0 00.975-.975v-3.9zM5.375 15.125h1.95M5.375 22.925h1.95M15.125 7.325v-1.95M22.925 7.325v-1.95"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M1.475 7.325h5.85v-5.85"
      })]
    })
  });
};
var PropertyTypeIcon = function PropertyTypeIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "33",
    height: "32",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      stroke: "#767676",
      strokeWidth: "1.95",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M5.88 18.3v10.725h7.8v-7.8a1.95 1.95 0 011.95-1.95h1.95a1.95 1.95 0 011.95 1.95v7.8h7.8V18.3M1.98 16.35L15.227 3.104a1.95 1.95 0 012.758 0L31.23 16.35"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M22.455 7.575v-1.95h4.875v6.825"
      })]
    })
  });
};
var LocationIcon = function LocationIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "32",
    height: "32",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      transform: "translate(0 -.5)",
      stroke: "#767676",
      strokeWidth: "1.95",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: "16.3",
        cy: "10.75",
        r: "3.9"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M16.3 1.975a8.775 8.775 0 018.775 8.775c0 4.226-6.672 13.685-8.38 16.038a.49.49 0 01-.79 0c-1.708-2.353-8.38-11.812-8.38-16.038A8.775 8.775 0 0116.3 1.975z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M24.073 24.12c3.551.703 5.877 1.876 5.877 3.205 0 2.154-6.11 3.9-13.65 3.9s-13.65-1.746-13.65-3.9c0-1.326 2.315-2.497 5.85-3.202"
      })]
    })
  });
};
var BedroomsIcon = function BedroomsIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "32",
    height: "32",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      stroke: "#767676",
      strokeWidth: "1.95",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M12.23 15.618a.488.488 0 10.491.482.486.486 0 00-.487-.488h0M20.875 4.4h5.85a1.95 1.95 0 011.95 1.95v19.5a1.95 1.95 0 01-1.95 1.95h-5.85"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M15.862 30.72l-11.7-1.672a.974.974 0 01-.837-.965V5.343c0-.46.321-.858.77-.955l11.7-2.887a.975.975 0 011.18.954v27.3a.975.975 0 01-1.113.965z"
      })]
    })
  });
};
var BedIcon = function BedIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "33",
    height: "33",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      stroke: "#767676",
      strokeWidth: "1.95",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "5.975",
        y: "1.975",
        width: "21.45",
        height: "29.25",
        rx: "1.95"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "11.825",
        y: "5.875",
        width: "9.75",
        height: "5.85",
        rx: "1.95"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M5.975 11.725h21.45M5.975 17.575h21.45"
      })]
    })
  });
};
var BathroomIcon = function BathroomIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "32",
    height: "32",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      stroke: "#767676",
      strokeWidth: "1.95",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M12.588 9.275a7.8 7.8 0 0115.6 0v21.45"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M6.737 15.125a5.85 5.85 0 0111.7 0h-11.7zM7.713 19.025l-.976 2.925M4.787 27.8l-.974 2.925M17.462 19.025l.976 2.925M20.387 27.8l.976 2.925M12.588 19.025v2.925M12.588 30.725V27.8"
      })]
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2269);
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/infoEntry/InfoEntry.jsx


var _excluded = ["description", "value", "Icon"];

function InfoEntry_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InfoEntry_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InfoEntry_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InfoEntry_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var InfoEntry = function InfoEntry(_ref) {
  var description = _ref.description,
      value = _ref.value,
      Icon = _ref.Icon,
      otherProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", InfoEntry_objectSpread(InfoEntry_objectSpread({
    className: "flex gap-16 items-center"
  }, otherProps), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        "data-testid": "description",
        children: description
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "font-bold",
        "data-testid": "value",
        children: value
      })]
    })]
  }));
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/info/Info.jsx
function Info_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = Info_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function Info_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return Info_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Info_arrayLikeToArray(o, minLen); }

function Info_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }






var Info = function Info() {
  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.objectData;
  }),
      estateSize = _useSelector.estateSize,
      noOfBedrooms = _useSelector.noOfBedrooms,
      noOfBeds = _useSelector.noOfBeds,
      noOfBathrooms = _useSelector.noOfBathrooms,
      propertyType = _useSelector.propertyType,
      situation = _useSelector.situation;

  var entryData = [['estateSize', {
    displayName: 'Størrelse',
    icon: EstateSizeIcon,
    value: estateSize
  }], ['noOfBedrooms', {
    displayName: 'Soverom',
    icon: BedroomsIcon,
    value: noOfBedrooms
  }], ['noOfBeds', {
    displayName: 'Sengeplasser',
    icon: BedIcon,
    value: noOfBeds
  }], ['noOfBathrooms', {
    displayName: 'Bad',
    icon: BathroomIcon,
    value: noOfBathrooms
  }], ['propertyType', {
    displayName: 'Boligtype',
    icon: PropertyTypeIcon,
    value: propertyType
  }], ['situation', {
    displayName: 'Beliggenhet',
    icon: LocationIcon,
    value: situation
  }]];

  var renderListEntries = function renderListEntries() {
    var entries = [];

    var _iterator = Info_createForOfIteratorHelper(entryData),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var entry = _step.value;
        var name = entry[0];
        var _entry$ = entry[1],
            displayName = _entry$.displayName,
            icon = _entry$.icon,
            value = _entry$.value;

        if (!value) {
          continue;
        }

        entries.push( /*#__PURE__*/(0,jsx_runtime.jsx)(InfoEntry, {
          description: displayName,
          value: value,
          Icon: icon,
          "data-testid": "adInfo-".concat(name)
        }, "list-".concat(name)));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return entries;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "grid grid-cols-2 md:grid-cols-3 gap-16",
    "data-testid": "adInfo",
    children: renderListEntries()
  });
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/infoList/InfoList.jsx




var profiled = ['Aircondition', 'Internettilgang', 'Balkong/terrasse', 'Garasje/parkeringsplass', 'Innendørs svømmebasseng', 'Utendørs svømmebasseng', 'Basseng', 'Kjøkken'];
var InfoList = function InfoList(_ref) {
  var list = _ref.list,
      split = _ref.split;

  var listItems = function listItems(items) {
    return items.length ? items.map(function (item) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: item
      }, item);
    }) : null;
  };

  var splitFacilities = function splitFacilities(items) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [listItems(items.filter(function (item) {
        return profiled.indexOf(item) >= 0;
      })), listItems(items.filter(function (item) {
        return profiled.indexOf(item) < 0;
      }))]
    });
  };

  return list && list.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: "list grid grid-cols-2 md:grid-cols-3 gap-8",
    "data-testid": "adInfoList",
    children: split ? splitFacilities(list) : listItems(list)
  }) : null;
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/profileButton/ProfileButton.jsx


function ProfileButton_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProfileButton_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProfileButton_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProfileButton_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var ProfileButton_getConfig = config_default()(),
    _getConfig$publicRunt = ProfileButton_getConfig.publicRuntimeConfig,
    baseUrl = _getConfig$publicRunt.baseUrl,
    ProfileButton_contextPath = _getConfig$publicRunt.contextPath;

var ProfileButton = function ProfileButton(props) {
  var encodedCanonicalUrl = encodeURIComponent("".concat(baseUrl).concat(ProfileButton_contextPath, "/ad.html?finnkode=").concat(props.objectData.adId));
  var sendMessageLink = "/authorizemessaging.html?canonicalUrl=".concat(encodedCanonicalUrl, "&finnkode=").concat(props.objectData.adId);

  var renderSendMessageOrSeeAvailability = function renderSendMessageOrSeeAvailability() {
    if (props.objectData.isPrivate || !props.objectData.owner.deeplink && props.objectData.isAdmin) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("a", ProfileButton_objectSpread(ProfileButton_objectSpread({
        className: "button button--primary w-full max-w-full"
      }, replacePropsWithPreview({
        href: sendMessageLink,
        onClick: function onClick() {
          return (0,tracking/* trackSendMessage */.eF)({
            objectName: 'without calendar',
            objectData: props.objectData
          });
        }
      }, props.objectData.isPreview)), {}, {
        "data-testid": "sendMessage",
        children: "Send melding"
      }));
    } else {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: "button button--primary w-full max-w-full",
        href: props.objectData.owner.deeplink ? props.objectData.owner.deeplink : props.objectData.owner.url,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: function onClick() {
          return (0,tracking/* trackCheckPriceAndAvailability */.NV)({
            objectData: props.objectData
          });
        },
        "data-testid": "seeAvailability",
        children: "Se tilgjengelighet"
      });
    }
  };

  return !props.objectData.bookingEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "my-16",
    "data-testid": "profileButton",
    children: renderSendMessageOrSeeAvailability()
  });
};
// EXTERNAL MODULE: ./src/scenes/objectPage/components/profileCompany/styles.module.css
var profileCompany_styles_module = __webpack_require__(3397);
var profileCompany_styles_module_default = /*#__PURE__*/__webpack_require__.n(profileCompany_styles_module);
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/profileCompany/ProfileCompany.jsx





var ProfileCompany = function ProfileCompany(props) {
  var _props$objectData$org;

  var mobile = props.objectData.owner.mobile;
  var phone = props.objectData.owner.phone;

  var renderPhoneInformation = function renderPhoneInformation() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        "data-testid": "phoneType",
        children: phone ? 'Telefon: ' : 'Mobil: '
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          "data-testid": "companyPhone",
          href: "tel:".concat(phone ? phone : mobile),
          rel: "external",
          children: phone ? phone : mobile
        })
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "mb-16",
    "data-testid": "companyProfile",
    children: [((_props$objectData$org = props.objectData.organisation.logo) === null || _props$objectData$org === void 0 ? void 0 : _props$objectData$org.trim().length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      "data-testid": "logo",
      className: classnames_default()((profileCompany_styles_module_default()).logo, 'img-format__img'),
      alt: props.objectData.organisation.name,
      src: "https://images.finncdn.no/dynamic/1600w/logo/".concat(props.objectData.organisation.logo)
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mt-4",
      "data-testid": "ownerName",
      children: props.objectData.owner.name
    }), phone || mobile ? renderPhoneInformation() : null]
  });
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/profilePhoneNumberVerification/ProfilePhoneNumberVerification.jsx



var ProfilePhoneNumberVerification = function ProfilePhoneNumberVerification(_ref) {
  var handleSubmitNumber = _ref.handleSubmitNumber,
      invalidPin = _ref.invalidPin,
      invalidNumber = _ref.invalidNumber;

  var _useState = (0,react.useState)(''),
      phoneNumber = _useState[0],
      setPhoneNumber = _useState[1];

  var renderInfoText = function renderInfoText() {
    if (invalidNumber) {
      return 'Ugyldig mobilnummer! Fyll inn ditt mobilnummer og du vil motta en PIN kode.';
    } else if (invalidPin) {
      return 'Feil PIN-kode! Fyll inn ditt mobilnummer og du vil motta en PIN-kode.';
    } else {
      return 'For sikkerhets skyld. Skriv inn mobilnummeret ditt, så sender vi deg en kode. Dette er selvfølgelig gratis.';
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    "data-testid": "requestForm",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      "data-testid": "phoneInfoText",
      children: renderInfoText()
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "input input--text input--kill-bottom-margin mb-8",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
        htmlFor: "phoneNumberInput",
        children: "Mobilnummer"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        id: "phoneNumberInput",
        placeholder: "Mobilnummer",
        "data-testid": "phoneNumberInput",
        onChange: function onChange(event) {
          return setPhoneNumber(event.target.value);
        },
        value: phoneNumber
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      className: "button button--secondary",
      "data-testid": "phoneNumberSubmit",
      disabled: !phoneNumber,
      onClick: function onClick() {
        return handleSubmitNumber(phoneNumber);
      },
      children: "Send"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "text-14 mt-4",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: "https://hjelpesenter.finn.no/hc/no/articles/305314-Kjenn-igjen-svindelfors%C3%B8k-p%C3%A5-SMS",
        className: "link",
        rel: "noopener noreferrer",
        target: "_blank",
        children: "Hvorfor ber vi deg om dette?"
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/profilePinNumberVerification/ProfilePinNumberVerification.jsx




var ProfilePinNumberVerification = function ProfilePinNumberVerification(_ref) {
  var handleSubmitPin = _ref.handleSubmitPin;

  var _useState = (0,react.useState)(''),
      pin = _useState[0],
      setPin = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      "data-testid": "phonePinInfo",
      children: "Skriv inn koden du fikk tilsendt p\xE5 SMS"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "input input--text input--kill-bottom-margin mb-8",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        value: pin,
        placeholder: "Kode",
        "data-testid": "phonePinInput",
        onChange: function onChange(event) {
          return setPin(event.target.value);
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      className: "button button--secondary",
      "data-testid": "phonePinSubmit",
      disabled: !pin,
      onClick: function onClick() {
        return handleSubmitPin(pin);
      },
      children: "Send"
    })]
  });
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/profilePhone/ProfilePhone.jsx





var ProfilePhone = function ProfilePhone(_ref) {
  var adId = _ref.adId,
      isLoggedIn = _ref.isLoggedIn;

  var _useState = (0,react.useState)(false),
      displayLogin = _useState[0],
      setDisplayLogin = _useState[1];

  var _useState2 = (0,react.useState)(false),
      displayRequestForm = _useState2[0],
      setDisplayRequestForm = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      displayPinVerification = _useState3[0],
      setDisplayPinVerification = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      invalidPin = _useState4[0],
      setInvalidPin = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      invalidNumber = _useState5[0],
      setInvalidNumber = _useState5[1];

  var _useState6 = (0,react.useState)(''),
      adOwnerPhoneNumber = _useState6[0],
      setAdOwnerPhoneNumber = _useState6[1];

  var _useState7 = (0,react.useState)(''),
      userInputPhoneNumber = _useState7[0],
      setUserInputPhoneNumber = _useState7[1];

  var request = function request(query) {
    return fetch("/verification/properties/".concat(query), {
      credentials: 'include'
    }).then(function (response) {
      return response.json();
    });
  };

  var handleSubmitNumber = function handleSubmitNumber(phoneNumber) {
    return request("requestpincode.json?phoneNumber=".concat(phoneNumber, "&adId=").concat(adId)).then(function (json) {
      if (json.result && json.result.result.sendPinStatus === 'OK') {
        setDisplayRequestForm(false);
        setDisplayPinVerification(true);
        setUserInputPhoneNumber(phoneNumber);
      } else if (json.result && json.result.result.sendPinStatus === 'INVALID_NUMBER') {
        setInvalidNumber(true);
      }
    });
  };

  var handleSubmitPin = function handleSubmitPin(pin) {
    return request("validatepin.json?pin=".concat(pin, "&phoneNumber=").concat(userInputPhoneNumber, "&adId=").concat(adId)).then(function (json) {
      if (json.result && json.result.validationStatus === 'OK') {
        setDisplayRequestForm(false);
        setDisplayPinVerification(false);
        setDisplayLogin(false);
      } else if (json.result && json.result.validationStatus === 'WRONG_PIN') {
        setDisplayRequestForm(true);
        setInvalidPin(true);
      }

      setDisplayPinVerification(false);
    });
  };

  var handleShowPhone = function handleShowPhone(event) {
    event.preventDefault();

    if (displayRequestForm || displayPinVerification) {
      return; // ignore clicks while in verification process
    }

    if (isLoggedIn) {
      return request("phonenumbers.json?adId=".concat(adId)).then(function (json) {
        if (json.result && json.result.result.verified === 'OK') {
          var numbers = Object.values(json.result.result.phoneNumbers).shift();
          setAdOwnerPhoneNumber(numbers.mobile || numbers.phone);
        } else if (json.result && json.result.result.verified === 'NEED_VERIFICATION') {
          setDisplayRequestForm(true);
        }
      });
    } else {
      setDisplayLogin(true);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "text-14 mt-8",
    "data-testid": "phoneNumber",
    children: [adOwnerPhoneNumber ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: "tel:".concat(adOwnerPhoneNumber),
      "data-testid": "phoneNumberLink",
      children: adOwnerPhoneNumber
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: "link",
      href: "#",
      onClick: handleShowPhone,
      role: "button",
      children: "Vis mobilnummer"
    }), displayRequestForm && /*#__PURE__*/(0,jsx_runtime.jsx)(ProfilePhoneNumberVerification, {
      handleSubmitNumber: handleSubmitNumber,
      invalidNumber: invalidNumber,
      invalidPin: invalidPin
    }), displayPinVerification && /*#__PURE__*/(0,jsx_runtime.jsx)(ProfilePinNumberVerification, {
      handleSubmitPin: handleSubmitPin
    }), displayLogin && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mt-8",
      "data-testid": "loginInfo",
      children: ["Du m\xE5 v\xE6re innlogget for \xE5 se nummeret.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        "data-testid": "phoneLogin",
        href: "/auth/login",
        children: "Logg inn"
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/profileFallbackAvatar/ProfileFallbackAvatar.jsx



var ProfileFallbackAvatar = function ProfileFallbackAvatar() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    viewBox: "0 0 220 220",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    role: "img",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        fill: "#B5EEFE",
        cx: "110",
        cy: "110",
        r: "110"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        fill: "#FFFFFF",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M31 174.077C49.622 197.21 78.093 212 110 212c31.907 0 60.378-14.79 79-37.923C172.56 147.61 143.325 130 110 130s-62.56 17.61-79 44.077z"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
          cx: "110",
          cy: "76",
          r: "46"
        })]
      })]
    })
  });
};
// EXTERNAL MODULE: ./src/scenes/objectPage/components/profileAnonymous/styles.module.css
var profileAnonymous_styles_module = __webpack_require__(1527);
var profileAnonymous_styles_module_default = /*#__PURE__*/__webpack_require__.n(profileAnonymous_styles_module);
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/profileAnonymous/ProfileAnonymous.jsx






var ProfileAnonymous = function ProfileAnonymous() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (profileAnonymous_styles_module_default()).ProfileAnonymous,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()((profileAnonymous_styles_module_default()).contaiuner, 'text-16'),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "profile-identity-avatar",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          role: "img",
          "aria-label": "Bilde av en anonym avatar",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileFallbackAvatar, {
            className: "profile-identity-avatar_img"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: "FINN-bruker"
      })]
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/moment/moment.js
var moment = __webpack_require__(9034);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/scenes/objectPage/components/profilePublic/styles.module.css
var profilePublic_styles_module = __webpack_require__(1412);
var profilePublic_styles_module_default = /*#__PURE__*/__webpack_require__.n(profilePublic_styles_module);
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/profilePublic/ProfilePublic.jsx


function ProfilePublic_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProfilePublic_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProfilePublic_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProfilePublic_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var AvatarWithProfile = function AvatarWithProfile(_ref) {
  var localProfileId = _ref.localProfileId,
      avatar = _ref.avatar,
      name = _ref.name;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "profile-identity-avatar",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      "data-testid": "profileLink",
      href: "/user/profile/profile.html?id=".concat(localProfileId),
      className: "profile-identity-avatar",
      children: avatar ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: "profile-identity-avatar_img",
        src: avatar,
        alt: name
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        role: "img",
        "aria-label": "Standard avatar n\xE5r en bruker ikke har lastet opp eget bilde",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileFallbackAvatar, {
          className: "profile-identity-avatar_img"
        })
      })
    })
  });
};

var AvatarWithoutProfile = function AvatarWithoutProfile(_ref2) {
  var avatar = _ref2.avatar,
      name = _ref2.name;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    "data-testid": "profileNoLink",
    className: "profile-identity-avatar",
    children: avatar ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      className: "profile-identity-avatar_img",
      src: avatar,
      alt: name
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      role: "img",
      "aria-label": "Bilde av en anonym avatar",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileFallbackAvatar, {
        className: "profile-identity-avatar_img"
      })
    })
  });
};

var ProfilePublic = function ProfilePublic(_ref3) {
  var identity = _ref3.identity;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (profilePublic_styles_module_default()).ProfilePublic,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      role: "heading",
      "aria-level": "2",
      className: (profilePublic_styles_module_default()).heading,
      children: "Profilinformasjon om selgeren"
    }), identity !== null && identity !== void 0 && identity.localProfileId ? /*#__PURE__*/(0,jsx_runtime.jsx)(AvatarWithProfile, ProfilePublic_objectSpread({}, identity)) : /*#__PURE__*/(0,jsx_runtime.jsx)(AvatarWithoutProfile, ProfilePublic_objectSpread({}, identity)), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (profilePublic_styles_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (profilePublic_styles_module_default()).identity,
        children: [identity ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "/user/profile/profile.html?id=".concat(identity.localProfileId),
          className: classnames_default()((profilePublic_styles_module_default()).link, 'profile-link'),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            "data-testid": "profileName",
            children: identity.name
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-testid": "profileName",
          children: "FINN-bruker"
        }), identity !== null && identity !== void 0 && identity.verified ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          "data-testid": "verifiedUser",
          href: "/eid/verification.html",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            role: "img",
            "aria-label": "Verifisert bruker",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
              viewBox: "0 0 18 18",
              xmlns: "http://www.w3.org/2000/svg",
              height: "32px",
              width: "32px",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  fill: "#0063FB",
                  d: "M3 4.545L9 2l6 2.545C15 9 15 14.091 9 16 3 14.09 3 9 3 4.545z"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  fill: "#FFF",
                  fillRule: "nonzero",
                  d: "M6.877 7.417L5.5 8.771 8.276 11.5 12.5 7.354 11.125 6 8.277 8.794z"
                })]
              })
            })
          })
        }) : null]
      }), identity !== null && identity !== void 0 && identity.memberSince && moment_default()(identity.memberSince).isValid() ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        "data-testid": "memberSince",
        className: "text-14",
        children: ["Har v\xE6rt p\xE5 FINN siden ", moment_default()(identity.memberSince).year()]
      }) : null]
    })]
  });
};
// EXTERNAL MODULE: ./src/scenes/objectPage/components/profileTrust/styles.module.css
var profileTrust_styles_module = __webpack_require__(4308);
var profileTrust_styles_module_default = /*#__PURE__*/__webpack_require__.n(profileTrust_styles_module);
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/profileTrust/ProfileTrust.jsx








var ProfileTrust = function ProfileTrust(_ref) {
  var adId = _ref.adId,
      isLoggedIn = _ref.isLoggedIn,
      owner = _ref.owner,
      profileIdentity = _ref.profileIdentity;
  var showAnonymousProfile = owner.isAnonymous || false;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    "data-testid": "trustProfile",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()((profileTrust_styles_module_default()).container, 'finn-trust-profile text-left'),
      children: showAnonymousProfile ? /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileAnonymous, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(ProfilePublic, {
        identity: profileIdentity
      })
    }), owner.hasPhoneNumber && /*#__PURE__*/(0,jsx_runtime.jsx)(ProfilePhone, {
      adId: adId,
      isLoggedIn: isLoggedIn
    })]
  });
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/profile/Profile.jsx










var Profile_getConfig = config_default()(),
    Profile_contextPath = Profile_getConfig.publicRuntimeConfig.contextPath;

var Profile = function Profile(_ref) {
  var isLoggedIn = _ref.isLoggedIn;
  var objectData = (0,es/* useSelector */.v9)(function (state) {
    return state.objectData;
  });
  var profileIdentity = (0,es/* useSelector */.v9)(function (state) {
    return state.profileData.identity;
  });
  var owner = objectData.owner,
      adId = objectData.adId,
      isAdmin = objectData.isAdmin,
      isImport = objectData.isImport,
      moreAdsQuery = objectData.moreAdsQuery; // Pulse tracker id: CE_ev20
  // TODO why use Common Elements (CE) and not our own definition?

  var trackHomepageClick = function trackHomepageClick() {
    return (0,tracking/* trackClick */.ob)({
      type: 'Click',
      intent: 'Open',
      name: 'Homepage link clicked',
      object: {
        id: 'homepage_link_clicked',
        type: 'UIElement',
        elementType: 'Link'
      },
      target: {
        id: owner.url,
        type: 'ExternalContent',
        name: 'Go to webpage',
        referralCommission: false,
        provider: owner.name
      },
      vertical: {
        name: 'travel',
        subVertical: 'holiday_rental'
      }
    });
  }; // Pulse tracker id: FHH_ev02


  var trackMoreAdsClick = function trackMoreAdsClick() {
    return (0,tracking/* trackClick */.ob)({
      type: 'Click',
      intent: 'View',
      name: 'More ads from this advertiser',
      object: {
        id: 'more_ads_from_this_advertiser',
        type: 'UIElement',
        elementType: 'Link',
        hasExtendedProfile: false
      },
      target: {
        id: 'https://www.finn.no/reise/feriehus-hytteutleie/resultat/',
        type: 'Listing',
        name: 'Result page'
      },
      vertical: {
        name: 'travel',
        subVertical: 'holiday_rental'
      }
    });
  };

  if (!owner) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    "data-testid": "adProfile",
    children: [isAdmin || isImport ? /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileCompany, {
      objectData: objectData
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileTrust, {
      profileIdentity: profileIdentity,
      owner: owner,
      adId: adId,
      isLoggedIn: isLoggedIn
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileButton, {
      objectData: objectData
    }), !isImport && owner.url && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: "".concat(Profile_contextPath, "/ut?finnkode=").concat(adId, "&deepLinkParams="),
      "data-testid": "webpage",
      className: "block",
      target: "_blank",
      rel: "noopener noreferrer nofollow external",
      onClick: function onClick() {
        return trackHomepageClick();
      },
      children: "Hjemmeside"
    }), moreAdsQuery && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      "data-testid": "more-ads",
      className: "block",
      href: "".concat(Profile_contextPath, "/resultat/?").concat(moreAdsQuery),
      onClick: function onClick() {
        return trackMoreAdsClick();
      },
      children: "Andre annonser fra samme utleier"
    })]
  });
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/locationMap/LocationMap.jsx


function LocationMap_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LocationMap_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LocationMap_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LocationMap_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var LocationMap = function LocationMap(_ref) {
  var adId = _ref.adId,
      location = _ref.location,
      isPreview = _ref.isPreview;
  var latlng = "lat=".concat(location.latitude, "&lng=").concat(location.longitude);
  var locationText = (location === null || location === void 0 ? void 0 : location.address) || location.locality; // TODO REIS-4591 Switch to only location.address when we switch to fasaden

  if (location.address && !location.address.includes(location.locality)) {
    locationText += ", ".concat(location.locality);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mb-16",
      "data-testid": "locationText",
      children: "".concat(locationText)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "img-format block",
      "data-testid": "adLocation",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", LocationMap_objectSpread(LocationMap_objectSpread({}, replacePropsWithPreview({
        href: "https://kart.finn.no/?finnkode=".concat(adId, "&").concat(latlng, "&mapType=finnvector&showPin=1&bl=1"),
        rel: 'external'
      }, isPreview)), {}, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "https://maptiles.finncdn.no/staticmap?".concat(latlng, "&zoom=14&size=620x400&maptype=norwayVector&showPin=true"),
          alt: "Kart",
          className: "img-format__img rounded-8",
          sizes: "(min-width: 1000px)"
        })
      }))
    })]
  });
};
LocationMap.defaultProps = {
  adId: 0,
  location: {
    address: '',
    locality: '',
    latitude: 0,
    longitude: 0
  }
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/footer/Footer.jsx


function Footer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Footer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Footer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Footer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var Footer = function Footer(_ref) {
  var adId = _ref.adId,
      heading = _ref.heading,
      modified = _ref.modified,
      isPreview = _ref.isPreview;

  var handleReportAdClick = function handleReportAdClick() {
    (0,tracking/* trackClick */.ob)({
      type: 'Click',
      intent: 'Report',
      name: 'Report ad',
      object: {
        type: 'UIElement',
        name: 'link',
        items: [{
          type: 'ClassifiedAd',
          id: adId,
          contentId: adId,
          name: heading,
          category: 'travel > holiday rental'
        }],
        hasExtendedProfile: false
      },
      target: {
        type: 'ClassifiedAd',
        name: 'Report Ad',
        contentId: adId
      },
      vertical: {
        name: 'travel',
        subVertical: 'holiday_rental'
      }
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "mx-0 sm:mx-16",
    "data-testid": "adFooter",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", Footer_objectSpread(Footer_objectSpread({
      "data-testid": "reportAd"
    }, replacePropsWithPreview({
      href: "/reportad.html?finnkode=".concat(adId),
      rel: 'external',
      onClick: handleReportAdClick
    }, isPreview)), {}, {
      children: "Rapporter annonse"
    })), /*#__PURE__*/(0,jsx_runtime.jsx)("table", {
      className: "mt-8",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("tbody", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
            className: "text-left whitespace-nowrap p-0",
            children: "FINN-kode"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
            className: "pl-16",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              "data-testid": "footerAdId",
              children: adId
            })
          })]
        }), modified && /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
            className: "text-left whitespace-nowrap p-0",
            children: "Sist endret"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
            className: "pl-16",
            "data-testid": "lastModified",
            children: modified
          })]
        })]
      })
    })]
  });
};
// EXTERNAL MODULE: ./src/lib/banner/lazyLoad.js
var lazyLoad = __webpack_require__(1080);
// EXTERNAL MODULE: ./src/scenes/objectPage/components/recommendationItem/styles.module.css
var recommendationItem_styles_module = __webpack_require__(9836);
var recommendationItem_styles_module_default = /*#__PURE__*/__webpack_require__.n(recommendationItem_styles_module);
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/recommendationItem/RecommendationItem.tsx








var RecommendationItem_getConfig = config_default()(),
    RecommendationItem_contextPath = RecommendationItem_getConfig.publicRuntimeConfig.contextPath;

var makeSrcSet = function makeSrcSet(path) {
  return path !== null && path !== void 0 && path.replace ? "".concat(path.replace('/default/', '/640w/'), " 640w, ") + "".concat(path.replace('/default/', '/320x240c/'), " 320w") : path;
};

var applyImageRule = function applyImageRule(url, rule) {
  return url !== null && url !== void 0 && url.replace ? url.replace('/default/', rule) : url;
};

var RecommendationItem = function RecommendationItem(_ref) {
  var image = _ref.image,
      version = _ref.version,
      score = _ref.score,
      itemId = _ref.itemId,
      heading = _ref.heading,
      label = _ref.label;
  var containerRef = (0,react.useRef)();

  var lazyLoadImage = function lazyLoadImage() {
    var elementArray = [containerRef.current];
    (0,lazyLoad/* lazyLoad */.u)(elementArray, function (thisElement) {
      var datasrc = thisElement.getAttribute('data-src');
      var datasrcset = thisElement.getAttribute('data-srcset');

      if (datasrc && datasrcset) {
        thisElement.src = datasrc;
        thisElement.srcset = datasrcset;
      }
    }, {
      proximity: 300,
      once: true
    });
  };

  (0,react.useEffect)(function () {
    lazyLoadImage();
  });

  var selectItem = function selectItem() {
    if (sessionStorage) {
      sessionStorage.setItem('searchParams', window.location.search);
    }
  };

  var renderImage = function renderImage() {
    return image !== null && image !== void 0 && image.url ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      className: "h-144 w-full object-cover",
      ref: containerRef,
      src: applyImageRule(image.url, '/480w/'),
      srcSet: makeSrcSet(image.url),
      "data-src": applyImageRule(image.url, '/480w/'),
      "data-srcset": makeSrcSet(image.url),
      alt: "Annonsebilde",
      "aria-hidden": "true",
      "data-testid": "adImage",
      sizes: "(min-width: 990px) 300px, (min-width: 768px) 33vw, (min-width: 480px) 50vw"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: 'https://static.finncdn.no/_c/mfinn/static/images/no_image_universal.4e750c62.png',
      className: "image-frame img-format__img",
      alt: "Bilde mangler",
      width: "320",
      height: "213",
      "aria-hidden": "true",
      "data-testid": "recImage"
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(npm/* Card */.Zb, {
    className: (recommendationItem_styles_module_default()).RecommendationItem,
    "data-version": version,
    "data-score": score,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      "aria-owns": "recTitle".concat(itemId)
    }), renderImage(), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "p-16 relative",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        className: "truncate text-16 font-normal text-gray-800",
        "data-testid": "recTitle",
        id: "recTitle".concat(itemId),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(npm/* Clickable */.P3, {
          href: "".concat(RecommendationItem_contextPath, "/ad.html?finnkode=").concat(itemId),
          target: "_blank",
          title: heading,
          className: "text-current hover:no-underline focus:no-underline",
          onClick: selectItem,
          children: heading
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "font-bold my-8",
        children: label !== null && label !== void 0 && label.includes('kr per år') ? 'Tilbyr åremål/langtidsleie' : label
      })]
    })]
  }, "recItem".concat(itemId));
};
// EXTERNAL MODULE: ./src/scenes/objectPage/components/recommendationList/styles.module.css
var recommendationList_styles_module = __webpack_require__(7240);
var recommendationList_styles_module_default = /*#__PURE__*/__webpack_require__.n(recommendationList_styles_module);
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/recommendationList/RecommendationList.tsx


function RecommendationList_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function RecommendationList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RecommendationList_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RecommendationList_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var RecommendationList = function RecommendationList(_ref) {
  var items = _ref.items;
  return items && items.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()((recommendationList_styles_module_default()).RecommendationList, 'grid grid-cols-2 md:grid-cols-3 gap-16 pb-32'),
    "data-testid": "adRecommendations",
    children: items.map(function (item) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(RecommendationItem, RecommendationList_objectSpread({}, item), item.itemId);
    })
  }) : null;
};
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/panel/Panel.jsx


var Panel_excluded = ["children", "title", "info", "bleed"];

function Panel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Panel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Panel_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Panel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Panel = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      title = _ref.title,
      info = _ref.info,
      bleed = _ref.bleed,
      otherProps = (0,objectWithoutProperties/* default */.Z)(_ref, Panel_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", Panel_objectSpread(Panel_objectSpread({
    className: "mx-0 ".concat(bleed ? '' : 'sm:mx-16', " ").concat(info ? 'p-16 rounded-8 bg-bluegray-100' : '')
  }, otherProps), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", Panel_objectSpread(Panel_objectSpread({
      className: "h3",
      "data-testid": "title"
    }, ref && {
      ref: ref,
      tabIndex: -1
    }), {}, {
      children: title
    })), children]
  }));
});
Panel.displayName = 'Panel';
Panel.propTypes = {
  children: (prop_types_default()).node.isRequired,
  title: (prop_types_default()).string.isRequired,
  info: (prop_types_default()).bool,
  bleed: (prop_types_default()).bool
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/links/Links.jsx






var Links = function Links(_ref) {
  var links = _ref.links;

  var pulseData = function pulseData(url, index) {
    return {
      type: 'Click',
      intent: 'Open',
      name: 'Useful links',
      object: {
        id: "useful_link_".concat(index),
        type: 'UIElement',
        elementType: 'Link',
        hasExtendedProfile: false
      },
      target: {
        id: url,
        type: 'ExternalContent',
        name: 'Go to webpage',
        referralCommission: false,
        provider: 'TODO' // TODO what to put here? Name of ad owner?

      },
      vertical: {
        name: 'travel',
        subVertical: 'holiday_rental'
      }
    };
  };

  return links && links.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Panel, {
    title: "Nyttige lenker",
    info: true,
    bleed: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      "data-testid": "adMoreInfo",
      children: links.map(function (info, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons_react/* IconLinkExternal16 */.H0p, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            rel: "noopener noreferrer nofollow external",
            target: "_blank",
            href: info.url,
            className: "link ml-8" // Pulse tracker id: FHH_ev03
            ,
            onClick: function onClick() {
              return (0,tracking/* trackClick */.ob)(pulseData(info.url, index));
            },
            "data-testid": "objectLink",
            children: info.text ? info.text : info.url
          }, "a".concat(index))]
        }, "span-".concat(index));
      })
    })
  }) : null;
};
// EXTERNAL MODULE: ../../node_modules/@finn-no/trust-web-sdk-finn/dist/trust-web-sdk-finn.js
var trust_web_sdk_finn = __webpack_require__(6484);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(304);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(9017);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(8200);
;// CONCATENATED MODULE: ../../shared/frontend-resources/src/util/ErrorBoundary.jsx







function ErrorBoundary_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ErrorBoundary_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ErrorBoundary_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ErrorBoundary_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  (0,createClass/* default */.Z)(ErrorBoundary, [{
    key: "componentDidCatch",
    value: // TODO REIS-4403: proper error logging should be done here
    function componentDidCatch(error, errorInfo) {
      console.error(error); // eslint-disable-line

      console.error(errorInfo); // eslint-disable-line
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return this.props.fallback || null;
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(react.Component);
var withErrorBoundary = function withErrorBoundary(Component) {
  var Wrapped = function Wrapped(props) {
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(Component, ErrorBoundary_objectSpread({}, props))
    });
  }; // Format for display in DevTools


  var name = Component.displayName || Component.name;
  Wrapped.displayName = name ? "WithErrorBoundary(".concat(name, ")") : 'WithErrorBoundary';
  return Wrapped;
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/rating/Rating.jsx


function Rating_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Rating_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Rating_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Rating_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var Rating_getConfig = config_default()(),
    feedbackApiUrl = Rating_getConfig.publicRuntimeConfig.trustUrl.feedbackApiUrl; // TODO: Merge with RatingDesktop..


var Rating = function Rating(_ref) {
  var adId = _ref.adId,
      isMobile = _ref.isMobile;

  var _useState = (0,react.useState)(false),
      trustFailed = _useState[0],
      setTrustFailed = _useState[1];

  var reputationWidget = (0,react.useRef)(null);
  var listingWidget = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    var settings = {
      itemSDRN: "sdrn:finn:classified:".concat(adId),
      apiUrl: feedbackApiUrl,
      locale: 'nb-NO',
      onError: function onError(e) {
        // eslint-disable-next-line no-console
        console.error("Problems with showing ratings for ".concat(adId), e);
        setTrustFailed(true);
      }
    };

    if (reputationWidget.current && listingWidget.current) {
      if (isMobile) {
        trust_web_sdk_finn/* trust.itemReputation.run */.z.itemReputation.run(reputationWidget.current, settings);
      } // Can use `newInstance: true` for the first render too as the behavior is the same


      trust_web_sdk_finn/* trust.publicFeedbackListing.run */.z.publicFeedbackListing.run(listingWidget.current, Rating_objectSpread(Rating_objectSpread({}, settings), {}, {
        newInstance: true
      }));
    }
  }, [trustFailed, adId]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorBoundary, {
    children: trustFailed ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: "Vi klarte ikke \xE5 hente vurderinger n\xE5, pr\xF8v igjen senere"
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        ref: reputationWidget,
        "data-trust-item-reputation-widget": "placeholder"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        ref: listingWidget,
        "data-trust-feedback-item-listing-widget": "placeholder",
        className: "mt-16"
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/lib/helpers/scroll.js
var scrollToElementByRef = function scrollToElementByRef(ref) {
  if (ref && ref.current) {
    var headerOffset = 50;
    var elementPosition = ref.current.getBoundingClientRect().top + window.scrollY;
    var offsetPosition = elementPosition - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};
var focusElementByRef = function focusElementByRef(ref) {
  if (ref && ref.current) {
    ref.current.focus({
      preventScroll: true
    });
  }
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/ratingDesktop/RatingDesktop.jsx









var RatingDesktop_getConfig = config_default()(),
    RatingDesktop_feedbackApiUrl = RatingDesktop_getConfig.publicRuntimeConfig.trustUrl.feedbackApiUrl; // TODO: Merge with ObjectRating..


var RatingDesktop = function RatingDesktop(_ref) {
  var adId = _ref.adId,
      isMobile = _ref.isMobile,
      ratingRef = _ref.ratingRef;

  var _useState = (0,react.useState)(false),
      trustFailed = _useState[0],
      setTrustFailed = _useState[1];

  var reputationWidget = (0,react.useRef)(null);

  var onClick = function onClick() {
    scrollToElementByRef(ratingRef);
    focusElementByRef(ratingRef);
  };

  (0,react.useEffect)(function () {
    var settings = {
      itemSDRN: "sdrn:finn:classified:".concat(adId),
      apiUrl: RatingDesktop_feedbackApiUrl,
      locale: 'nb-NO',
      onError: function onError(e) {
        // eslint-disable-next-line no-console
        console.error("Problems with showing ratings for ".concat(adId), e);
        setTrustFailed(true);
      }
    };

    if (reputationWidget.current) {
      trust_web_sdk_finn/* trust.itemReputation.run */.z.itemReputation.run(reputationWidget.current, settings);
    }
  }, [trustFailed, adId]);
  return !isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorBoundary, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "objectRatingWidgetDesktop",
      children: trustFailed ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: "Vi klarte ikke \xE5 hente vurderinger n\xE5, pr\xF8v igjen senere"
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mb-8",
          ref: reputationWidget,
          "data-trust-item-reputation-widget": "placeholder"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: "button button--link",
          onClick: onClick,
          children: "Se alle vurderinger"
        })]
      })
    })
  }) : null;
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/administration/Administration.jsx



var Administration = function Administration(_ref) {
  var adId = _ref.adId,
      isPreview = _ref.isPreview,
      user = _ref.user;
  var isOwner = Boolean(user === null || user === void 0 ? void 0 : user.isOwner);
  var name = (user === null || user === void 0 ? void 0 : user.name) || null;
  var greeting = name ? "Hei, ".concat(name, "!") : 'Hei!';

  if (!isOwner || isPreview) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "mx-0 sm:mx-16 mb-16",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: "/user/ads/admin.html?finnkode=".concat(adId),
      className: "link link--block",
      tabIndex: "0",
      "aria-label": "Endre annonsen og se statistikk",
      "data-testid": "adOwnerLink",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex gap-16",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            alt: "Statistikk-ikon"
            /* eslint-disable-next-line max-len */
            ,
            src: "https://static.finncdn.no/_c/mfinn/statistics-icon-27e6411db7df4441323f51ee25b143802cf852547ce19cd659d234b30e5eb685.svg",
            width: "75",
            height: "75"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "px-16 truncate",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            className: "truncate mb-2 text-gray-700",
            children: greeting
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "truncate mb-2 text-gray-700",
            children: "Dette er din annonse."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "truncate mb-2",
            children: "Endre annonsen og se statistikk"
          })]
        })]
      })
    })
  });
};
// EXTERNAL MODULE: ./src/scenes/objectPage/components/description/styles.module.css
var description_styles_module = __webpack_require__(3362);
var description_styles_module_default = /*#__PURE__*/__webpack_require__.n(description_styles_module);
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/description/Description.jsx







var Description = function Description(_ref) {
  var description = _ref.description;
  var longDescription = (description === null || description === void 0 ? void 0 : description.length) > 671;

  var _useState = (0,react.useState)(!longDescription),
      expanded = _useState[0],
      setExpanded = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "overflow-hidden",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-0 relative",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "preserve-linebreaks",
        "data-testid": "adDescription",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-testid": "value",
          className: classnames_default()((description_styles_module_default()).description, (0,defineProperty/* default */.Z)({}, (description_styles_module_default())["description--expanded"], expanded)),
          dangerouslySetInnerHTML: {
            __html: description
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: expanded ? '' : 'read-more',
        children: longDescription && /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
          className: "button button--link mt-8",
          onClick: function onClick() {
            return setExpanded(!expanded);
          },
          children: [expanded ? /*#__PURE__*/(0,jsx_runtime.jsx)(icons_react/* IconMinus16 */.wK$, {
            className: "inline-block mr-8"
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(icons_react/* IconPlus16 */.ug1, {
            className: "inline-block mr-8"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "align-text-top",
            children: expanded ? 'Vis mindre' : 'Vis mer'
          })]
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/digitalContract/DigitalContract.jsx


function DigitalContract_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DigitalContract_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DigitalContract_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DigitalContract_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var DigitalContract = function DigitalContract(_ref) {
  var adId = _ref.adId,
      isPreview = _ref.isPreview;
  var digitalContractUrl = "https://swiftcourt.com/no/finn-vacation-rental?finn_id=".concat(adId); // Pulse tracker id: FHH_ev01

  var pulseData = function pulseData() {
    return {
      type: 'Click',
      intent: 'Create',
      name: 'Create digital contract',
      object: {
        id: 'create_digital_contract',
        type: 'UIElement',
        elementType: 'Button',
        hasExtendedProfile: false
      },
      target: {
        id: digitalContractUrl,
        type: 'ExternalContent',
        name: 'Go to webpage',
        referralCommission: false,
        provider: 'Swiftcourt'
      },
      vertical: {
        name: 'travel',
        subVertical: 'holiday_rental'
      }
    };
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      className: "list list-checked mb-16",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "Utfylt kontrakt med opplysninger fra annonsen"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "Signer kontrakten elektronisk"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "Gratis tjeneste"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", DigitalContract_objectSpread(DigitalContract_objectSpread({
      className: "button button--secondary w-full max-w-full",
      rel: "noopener noreferrer nofollow external",
      target: "_blank"
    }, replacePropsWithPreview({
      href: digitalContractUrl,
      onClick: function onClick() {
        return (0,tracking/* trackClick */.ob)(pulseData());
      }
    }, isPreview)), {}, {
      "data-testid": "digitalContract",
      children: "Opprett digital leiekontrakt"
    }))]
  });
};
// EXTERNAL MODULE: ../../node_modules/@eiendomsprofil/finn-widget-web/dist/index.js
var finn_widget_web_dist = __webpack_require__(1215);
var dist_default = /*#__PURE__*/__webpack_require__.n(finn_widget_web_dist);
// EXTERNAL MODULE: ../../node_modules/@eiendomsprofil/finn-widget-web/dist/style.css
var style = __webpack_require__(5793);
// EXTERNAL MODULE: ./src/scenes/objectPage/components/areaProfile/styles.module.css
var areaProfile_styles_module = __webpack_require__(5359);
var areaProfile_styles_module_default = /*#__PURE__*/__webpack_require__.n(areaProfile_styles_module);
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/areaProfile/AreaProfile.jsx









var AreaProfile_getConfig = config_default()(),
    AreaProfile_contextPath = AreaProfile_getConfig.publicRuntimeConfig.contextPath;

var AreaProfile = function AreaProfile(_ref) {
  var adId = _ref.adId;

  var _useState = (0,react.useState)(false),
      isClient = _useState[0],
      setIsClient = _useState[1];

  (0,react.useEffect)(function () {
    return setIsClient(true);
  }, []);
  var endpoint = "".concat(AreaProfile_contextPath, "/api/area-profile/?id=").concat(adId);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()((areaProfile_styles_module_default()).AreaProfile, 'mx-0 sm:mx-16 nabolag-widget'),
    children: isClient && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorBoundary, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((dist_default()), {
        endpoint: endpoint,
        config: {
          resizeThrottleMs: 150,
          scrollThrottleMs: 66
        }
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/status/Status.jsx


var Status = function Status(_ref) {
  var status = _ref.status;

  var statusText = function statusText() {
    if (status.isExpired) {
      return 'Utgått';
    } else if (status.isDeleted) {
      return 'Slettet';
    } else if (status.isRented) {
      return 'Utleid';
    } else {
      return 'Inaktiv';
    }
  };

  var statusClass = status.isRented ? 'bg-yellow-100' : 'bg-red-200';
  return !status || status.isActive ? null : /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
    "data-testid": "adStatus",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "px-8 py-4 rounded-4 ".concat(statusClass),
      "data-testid": "objectStatus",
      children: statusText().toUpperCase()
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/@finn-no/troika-react-bottom-sheet/dist/index.es.js + 58 modules
var index_es = __webpack_require__(5058);
// EXTERNAL MODULE: ../../node_modules/@finn-no/troika-react-bottom-sheet/dist/style.css
var dist_style = __webpack_require__(5649);
;// CONCATENATED MODULE: ./src/scenes/objectPage/components/previewBottomSheet/PreviewBottomSheet.jsx







var PreviewBottomSheet_getConfig = config_default()(),
    PreviewBottomSheet_getConfig$publicRunt = PreviewBottomSheet_getConfig.publicRuntimeConfig,
    adInUrl = PreviewBottomSheet_getConfig$publicRunt.adInUrl,
    adminUrl = PreviewBottomSheet_getConfig$publicRunt.adminUrl;

var PreviewBottomSheet = function PreviewBottomSheet(_ref) {
  var adId = _ref.adId,
      isPrivate = _ref.isPrivate,
      isAdmin = _ref.isAdmin;
  var editAdUrl = isPrivate ? "".concat(adInUrl, "/").concat(adId) : isAdmin ? "".concat(adminUrl, "?finnkode=").concat(adId) : undefined;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* BottomSheet */.R, {
    open: true,
    blocking: false,
    scrollLocking: false,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "p-16 sm:p-32 grid md:grid-cols-2 gap-16",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "font-bold text-22",
          children: "Sjekk annonsen f\xF8r den legges ut"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          className: "list list-checked",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: "Sjekk at teksten er som den skal - er det noen skrivefeil?"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: "Har du sjekket at bildene er gode?"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: "button button--primary",
          href: editAdUrl,
          children: "Endre annonsen"
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/scenes/objectPage/ObjectPage.jsx


function ObjectPage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ObjectPage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ObjectPage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ObjectPage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
































var ObjectPage = function ObjectPage(_ref) {
  var _recommendationData$i;

  var deviceType = _ref.deviceType,
      loginCookieCsrfToken = _ref.loginCookieCsrfToken,
      loginId = _ref.loginId,
      unleash = _ref.unleash;
  var dispatch = (0,es/* useDispatch */.I0)();
  var router = (0,next_router.useRouter)();
  var finnCode = router.query.finnkode;
  var objectData = (0,es/* useSelector */.v9)(function (state) {
    return state.objectData;
  });
  var adId = objectData.adId,
      areaDescription = objectData.areaDescription,
      description = objectData.description,
      facilities = objectData.facilities,
      heading = objectData.heading,
      images = objectData.images,
      objectDataIsPreview = objectData.isPreview,
      isPrivate = objectData.isPrivate,
      location = objectData.location,
      modified = objectData.modified,
      moreInfo = objectData.moreInfo,
      poiNearBy = objectData.poiNearBy,
      priceInfo = objectData.priceInfo,
      pricing = objectData.pricing,
      recommendationData = objectData.recommendationData,
      residenceDescription = objectData.residenceDescription,
      roomsDescription = objectData.roomsDescription,
      status = objectData.status,
      user = objectData.user;
  var filters = (0,es/* useSelector */.v9)(function (state) {
    return state.results.filters;
  });

  var _useState = (0,react.useState)(false),
      initialBannerEventPublished = _useState[0],
      setInitialBannerEventPublished = _useState[1];

  var isMobile = Boolean(deviceType.isProbablyMobile);
  var isPreview = Boolean(objectDataIsPreview);
  var isLoggedIn = loginId !== null;
  var ratingRef = (0,react.useRef)(null);
  var objectPricingColumnData = pricing !== null && pricing !== void 0 && pricing.year ? [{
    description: 'Åremål/langtidsleie',
    value: 'Kontakt utleier'
  }] : [];

  var newPricing = ObjectPage_objectSpread({}, pricing);

  delete newPricing.year;
  (0,react.useEffect)(function () {
    if (isPreview) {
      return;
    } // Pulse tracker id: FHH_pv02 (see tracking section in README.md)


    (0,tracking/* trackPageView */.Z0)({
      type: 'ClassifiedAd',
      contentId: finnCode,
      externalPartners: [{
        brandName: objectData.isImport ? objectData.owner.name : undefined
      }]
    });
    trackAdView({
      adId: adId || finnCode
    });
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [finnCode, isPreview]);
  (0,react.useEffect)(function () {
    if (isPreview || !adId || initialBannerEventPublished) {
      return;
    }

    publishBannerEvent();
    setInitialBannerEventPublished(true);
  }, [adId, initialBannerEventPublished, isPreview]);
  (0,react.useEffect)(function () {
    if (isPreview || !adId) {
      return;
    }

    dispatch((0,objectActions/* populateObjectPriceInfo */.uH)(adId));
    dispatch((0,objectActions/* fetchObjectRecommendations */.nj)(adId));
  }, [adId, isPreview]);
  (0,react.useEffect)(function () {
    if (isPreview || adId || !finnCode) {
      return;
    }

    dispatch((0,objectActions/* populateObject */.Zb)(finnCode));
  }, [adId, finnCode, isPreview]);

  if (!adId) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      "data-testid": "objectPage"
    });
  }

  var renderProfileAndCalendar = function renderProfileAndCalendar() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "space-y-16",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "p-16 border rounded-8 text-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Profile, {
          isLoggedIn: isLoggedIn
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Calendar, {
          deviceType: deviceType,
          filters: filters,
          loginCookieCsrfToken: loginCookieCsrfToken,
          isLoggedIn: isLoggedIn,
          unleash: unleash,
          isPreview: isPreview
        })]
      }), !isPreview && /*#__PURE__*/(0,jsx_runtime.jsx)(RatingDesktop, {
        adId: adId,
        isMobile: isMobile,
        ratingRef: ratingRef
      }), isPrivate && /*#__PURE__*/(0,jsx_runtime.jsx)(Panel, {
        title: "Trenger du en kontrakt?",
        info: true,
        bleed: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DigitalContract, {
          adId: adId,
          isPreview: isPreview
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Links, {
        links: moreInfo
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    "data-testid": "objectPage",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumbs/* FhhBreadcrumbs */.X, {
      className: "mx-0 sm:mx-16 pt-8",
      isPreview: isPreview
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Administration, {
      adId: adId,
      isPreview: isPreview,
      user: user
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "grid md:grid-cols-3 gap-16 pb-32",
      children: [heading && images && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageList, {
        adId: adId,
        heading: heading,
        images: images
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
        className: "md:col-span-2 space-y-24",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mx-0 sm:mx-16 flex space-x-8 sm:space-x-16 items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FavoriteButton, {
            adId: adId,
            loginId: loginId,
            isMobile: isMobile,
            isPreview: isPreview
          }), adId && heading && /*#__PURE__*/(0,jsx_runtime.jsx)(ShareButtons, {
            adId: adId,
            heading: heading,
            isEnabled: Boolean((status === null || status === void 0 ? void 0 : status.isActive) && !isPreview)
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mx-0 sm:mx-16 space-y-32",
          children: [status && /*#__PURE__*/(0,jsx_runtime.jsx)(Status, {
            status: status
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            "data-testid": "adHeading",
            className: "break-words",
            children: heading
          }), priceInfo ? /*#__PURE__*/(0,jsx_runtime.jsx)(Pricing, {
            pricing: priceInfo,
            firstColumnList: objectPricingColumnData
          }) : newPricing && /*#__PURE__*/(0,jsx_runtime.jsx)(Pricing, {
            pricing: newPricing,
            firstColumnList: objectPricingColumnData
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Info, {})]
        }), residenceDescription && /*#__PURE__*/(0,jsx_runtime.jsx)(Panel, {
          title: "Om boligen",
          "data-testid": "residence-title",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
            description: residenceDescription,
            "data-testid": "residence-description"
          })
        }), !residenceDescription && description && /*#__PURE__*/(0,jsx_runtime.jsx)(Panel, {
          title: "Beskrivelse",
          "data-testid": "description-title",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
            description: description,
            "data-testid": "description"
          })
        }), roomsDescription && /*#__PURE__*/(0,jsx_runtime.jsx)(Panel, {
          title: "Beskrivelse av rom",
          "data-testid": "rooms-title",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
            description: roomsDescription,
            "data-testid": "room-description"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Panel, {
          title: "Fasiliteter",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(InfoList, {
            list: facilities,
            split: true
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Panel, {
          title: "I n\xE6rheten",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(InfoList, {
            list: poiNearBy
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Panel, {
          title: "Beliggenhet",
          "data-testid": "area-title",
          children: [areaDescription && /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
            description: areaDescription,
            "data-testid": "area-description"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(LocationMap, {
            adId: adId,
            location: location,
            isPreview: isPreview
          })]
        }), isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-testid": "objectPage-mobileProfileAndCalendar",
          children: renderProfileAndCalendar()
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(AreaProfile, {
          adId: adId
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {
          adId: adId,
          heading: heading,
          isPreview: isPreview,
          modified: modified
        }), !isPreview && /*#__PURE__*/(0,jsx_runtime.jsx)(Panel, {
          title: "Vurderinger fra gjester",
          ref: ratingRef,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Rating, {
            adId: adId,
            isMobile: isMobile
          })
        })]
      }), !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        "data-testid": "objectPage-profileAndCalendar",
        children: renderProfileAndCalendar()
      })]
    }), (recommendationData === null || recommendationData === void 0 ? void 0 : (_recommendationData$i = recommendationData.items) === null || _recommendationData$i === void 0 ? void 0 : _recommendationData$i.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Panel, {
      title: "Andre feriehus og hytter",
      "data-testid": "objectPage-recommendations",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(RecommendationList, {
        items: recommendationData.items
      })
    })]
  });
};
ObjectPage.PreviewBottomSheet = PreviewBottomSheet;

/***/ }),

/***/ 2208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ SpinnerIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);



var SpinnerIcon = function SpinnerIcon(_ref) {
  var className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 22 : _ref$size;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "#09f",
    viewBox: "0 0 32 32",
    className: className,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
      cx: "16",
      cy: "3",
      r: "0",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("animate", {
        attributeName: "r",
        begin: "0",
        calcMode: "spline",
        dur: "1s",
        keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
        repeatCount: "indefinite",
        values: "0;3;0;0"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
      cx: "16",
      cy: "3",
      r: "0",
      transform: "rotate(45 16 16)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("animate", {
        attributeName: "r",
        begin: "0.125s",
        calcMode: "spline",
        dur: "1s",
        keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
        repeatCount: "indefinite",
        values: "0;3;0;0"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
      cx: "16",
      cy: "3",
      r: "0",
      transform: "rotate(90 16 16)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("animate", {
        attributeName: "r",
        begin: "0.25s",
        calcMode: "spline",
        dur: "1s",
        keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
        repeatCount: "indefinite",
        values: "0;3;0;0"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
      cx: "16",
      cy: "3",
      r: "0",
      transform: "rotate(135 16 16)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("animate", {
        attributeName: "r",
        begin: "0.375s",
        calcMode: "spline",
        dur: "1s",
        keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
        repeatCount: "indefinite",
        values: "0;3;0;0"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
      cx: "16",
      cy: "3",
      r: "0",
      transform: "rotate(180 16 16)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("animate", {
        attributeName: "r",
        begin: "0.5s",
        calcMode: "spline",
        dur: "1s",
        keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
        repeatCount: "indefinite",
        values: "0;3;0;0"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
      cx: "16",
      cy: "3",
      r: "0",
      transform: "rotate(225 16 16)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("animate", {
        attributeName: "r",
        begin: "0.625s",
        calcMode: "spline",
        dur: "1s",
        keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
        repeatCount: "indefinite",
        values: "0;3;0;0"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
      cx: "16",
      cy: "3",
      r: "0",
      transform: "rotate(270 16 16)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("animate", {
        attributeName: "r",
        begin: "0.75s",
        calcMode: "spline",
        dur: "1s",
        keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
        repeatCount: "indefinite",
        values: "0;3;0;0"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
      cx: "16",
      cy: "3",
      r: "0",
      transform: "rotate(315 16 16)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("animate", {
        attributeName: "r",
        begin: "0.875s",
        calcMode: "spline",
        dur: "1s",
        keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
        repeatCount: "indefinite",
        values: "0;3;0;0"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
      cx: "16",
      cy: "3",
      r: "0",
      transform: "rotate(180 16 16)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("animate", {
        attributeName: "r",
        begin: "0.5s",
        calcMode: "spline",
        dur: "1s",
        keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
        repeatCount: "indefinite",
        values: "0;3;0;0"
      })
    })]
  });
};

/***/ }),

/***/ 5359:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"AreaProfile":"styles_AreaProfile__kNmUV"};

/***/ }),

/***/ 8663:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"datePicker":"styles_datePicker__514iG"};

/***/ }),

/***/ 3362:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"description":"styles_description__nIDNe","description--expanded":"styles_description--expanded__hxcAI"};

/***/ }),

/***/ 9587:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageItemImg":"styles_imageItemImg__GCwvt","button":"styles_button__wFG7G"};

/***/ }),

/***/ 1527:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProfileAnonymous":"styles_ProfileAnonymous__QXRiI","container":"styles_container__3qtU0"};

/***/ }),

/***/ 3397:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__6AUN3"};

/***/ }),

/***/ 1412:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProfilePublic":"styles_ProfilePublic__1tcdb","container":"styles_container__dcGen","heading":"styles_heading__y3JfW","link":"styles_link__vAWec","identity":"styles_identity__KZUFI"};

/***/ }),

/***/ 4308:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__nXRS6"};

/***/ }),

/***/ 9836:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"RecommendationItem":"styles_RecommendationItem__E_z7B"};

/***/ }),

/***/ 7240:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"RecommendationList":"styles_RecommendationList__g6t_K"};

/***/ }),

/***/ 6463:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__cx5Ot","button--hightlight":"styles_button--hightlight__DGkpA"};

/***/ })

}]);